<template>
  <div id="question_page" class="question-page">
    <div class="relative">
      <div v-if="shadowScreen" class="full-screen-shadow"></div>
    </div>
    <div class="head-link-container flex-center">
      <div
        v-if="showBackBTN()"
        @click="step = backBTN()"
        class="bt-back flex-mid"
      >
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95079 0.302444C8.35364 0.705703 8.35364 1.35951 7.95079 1.76277L2.49082 7.22826L7.95079 12.6938C8.35364 13.097 8.35364 13.7508 7.95079 14.1541C7.54794 14.5573 6.89479 14.5573 6.49194 14.1541L0.302541 7.95843C-0.100311 7.55517 -0.100311 6.90136 0.302541 6.4981L6.49194 0.302444C6.89479 -0.100815 7.54794 -0.100815 7.95079 0.302444Z"
            fill="#037968"
          />
        </svg>
      </div>
      <div class="flex-mid m-auto">
        <span
          v-if="showStepValue()"
          class="fs-16 fw-500"
          style="color: #2d7617"
        >
          Step
          {{ showStepValue() }}
          of 8
        </span>
      </div>
      <div
        @click="$router.push('/home')"
        v-if="step != 'question_finish'"
        class="link right"
      >
        {{ $t("skip") }}
      </div>
    </div>
    <div class="step-progress">
      <div
        v-for="id in returnMockArray(showStepValue())"
        :key="id"
        class="step-bar fs-2"
      >
        &nbsp;
      </div>
    </div>
    <div
      v-if="step == 'let_start' || step == 'Sync_data_dialog'"
      class="center"
    >
      <div class="image-middle flex-mid mx-auto">
        <img
          src="@/assets/image/Question/girl-tapping-phone.gif"
          alt=""
          class="mx-auto"
          style="width: 100%; height: 100%; object-fit: scale-down"
        />
      </div>
      <div class="questionatitle" style="line-height: 22px">
        {{ $t("questionatitle") }}
      </div>
      <div
        @click="letStart()"
        style="width: 24rem"
        class="btn-question btn btn-48 mx-auto mt-28"
      >
        {{ $t("start") }}
      </div>
    </div>
    <div v-else-if="step == 'question_sex'" class="center sex-container">
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'ont-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("sex") }}
        </div>
        <div
          class="select-box flex-center mx-auto"
          style="margin-top: 4rem"
          @click="switchSex()"
        >
          <div :class="`button white-cyecle ${form.sex}`">&nbsp;</div>
          <div
            :class="`button mr-auto ml-10 flex-mid ${
              form.sex == 'M' ? 'focus' : ''
            }`"
          >
            <div class="center">
              <svg
                width="52"
                height="54"
                viewBox="0 0 52 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.9999 24.75C27.714 24.75 29.3896 24.2222 30.8149 23.2332C32.2401 22.2443 33.3509 20.8387 34.0069 19.1942C34.6628 17.5496 34.8345 15.74 34.5001 13.9942C34.1657 12.2484 33.3402 10.6447 32.1282 9.38604C30.9161 8.12737 29.3719 7.2702 27.6907 6.92294C26.0095 6.57567 24.267 6.7539 22.6833 7.43509C21.0997 8.11628 19.7462 9.26983 18.7938 10.7499C17.8415 12.2299 17.3333 13.97 17.3333 15.75C17.3333 18.137 18.2463 20.4261 19.8717 22.114C21.497 23.8018 23.7014 24.75 25.9999 24.75Z"
                  :fill="`${form.sex == 'M' ? '#2D7617' : '#525252'}`"
                />
                <path
                  d="M38.9999 47.25C39.5746 47.25 40.1257 47.0129 40.532 46.591C40.9383 46.169 41.1666 45.5967 41.1666 45C41.1666 40.8228 39.5687 36.8168 36.7244 33.8631C33.8801 30.9094 30.0224 29.25 25.9999 29.25C21.9775 29.25 18.1198 30.9094 15.2755 33.8631C12.4312 36.8168 10.8333 40.8228 10.8333 45C10.8333 45.5967 11.0615 46.169 11.4679 46.591C11.8742 47.0129 12.4253 47.25 12.9999 47.25H38.9999Z"
                  :fill="`${form.sex == 'M' ? '#2D7617' : '#525252'}`"
                />
              </svg>
              <br />
              {{ $t("male") }}
            </div>
          </div>
          <div
            :class="`button ml-auto mr-10 flex-mid ${
              form.sex == 'M' ? '' : 'focus'
            }`"
          >
            <div class="center">
              <svg
                width="31"
                height="41"
                viewBox="0 0 31 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.0795 40.8451C28.6524 40.8451 29.2018 40.6092 29.6068 40.1894C30.0119 39.7696 30.2395 39.2002 30.2395 38.6066C30.2395 34.4507 28.6465 30.4651 25.811 27.5265C22.9755 24.5879 19.1297 22.937 15.1197 22.937C11.1097 22.937 7.26397 24.5879 4.42847 27.5265C1.59297 30.4651 5.97537e-08 34.4507 0 38.6066C0 39.2002 0.227567 39.7696 0.632639 40.1894C1.03771 40.6092 1.5871 40.8451 2.15996 40.8451H28.0795Z"
                  :fill="`${form.sex == 'M' ? '#525252' : '#2D7617'}`"
                />
                <path
                  d="M24.3527 16.213H23.3367V8.64692C23.3367 3.87136 19.4653 0 14.6897 0C9.91419 0 6.04283 3.87136 6.04283 8.64692V16.213H5.08086C4.48392 16.213 4 16.6969 4 17.2938C4 17.8908 4.48392 18.3747 5.08086 18.3747H24.3527C24.9496 18.3747 25.4335 17.8908 25.4335 17.2938C25.4335 16.6969 24.9496 16.213 24.3527 16.213Z"
                  :fill="`${form.sex == 'M' ? '#525252' : '#2D7617'}`"
                />
              </svg>
              <br />
              {{ $t("female") }}
            </div>
          </div>
        </div>
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
          style="margin-top: 6rem"
        >
          {{ $t("dateofbirth") }}
        </div>
        <div class="flex-mid" style="margin-top: 6rem">
          <!-- <el-select
            v-model="form.dayOfBirth"
            @change="checkDayOfBirthValidate"
            :class="{ validate: formValidate.dayOfBirth }"
            class="ml-auto date-input"
            placeholder=" "
          >
            <el-option
              v-for="item in options.day"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select> -->
          <div class="relative">
            <div class="absolute-mid focus-bg-date"></div>
            <div class="absolute-mid top-bottom-bg-date"></div>
            <swiper
              v-if="form.monthOfBirth == 2 && isLeapYear == true"
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 29" :id="index" :key="index">
                <div
                  class="flex-mid fc-DBDBDB fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>

            <swiper
              v-else-if="form.monthOfBirth == 2 && isLeapYear == false"
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 28" :id="index" :key="index">
                <div
                  class="flex-mid fc-DBDBDB fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>

            <swiper
              v-else
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 31" :id="index" :key="index">
                <div
                  class="flex-mid fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <el-select
            v-model="form.monthOfBirth"
            @change="checkMonthOfBirthValidate"
            :class="{ validate: formValidate.monthOfBirth }"
            class="ml-6 mr-6 date-input"
            placeholder=" "
          >
            <el-option
              v-for="item in options.month"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select> -->
          <div class="relative">
            <div class="absolute-mid focus-bg-month"></div>
            <div class="absolute-mid top-bottom-bg-month"></div>
            <swiper
              :direction="'vertical'"
              class="date-selected-month"
              :slides-per-view="3"
              :centeredSlides="true"
              :initialSlide="form.monthOfBirth - 1"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideMonthChange"
            >
              <swiper-slide
                v-for="(item, index) in options.month"
                :id="index"
                :key="index"
              >
                <div
                  class="flex-mid fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ $t(item) }}
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <div class="relative">
            <div class="absolute-mid focus-bg-year"></div>
            <div class="absolute-mid top-bottom-bg-year"></div>
            <swiper
              :direction="'vertical'"
              class="date-selected-year"
              :slides-per-view="3"
              :centeredSlides="true"
              :initialSlide="
                getArrForYears().indexOf(parseInt(form.yearOfBirth))
              "
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideYearChange"
            >
              <swiper-slide
                v-for="item in getArrForYears()"
                :id="item"
                :key="item"
              >
                <div
                  v-if="lang == 'th'"
                  class="flex-mid fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ item + 543 }}
                </div>

                <div
                  v-else
                  class="flex-mid fs-18 fw-400"
                  style="height: 3.6rem; color: #000"
                >
                  {{ item }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <el-date-picker
            v-model="dayOfBirth"
            type="date"
            placeholder="Pick a date"
          /> -->
          <!-- <el-date-picker
            v-model="form.monthOfBirth"
            type="month"
            placeholder="Pick a month"
          /> -->
          <!-- <el-date-picker
            v-model="form.yearOfBirth"
            type="year"
            placeholder="Pick a year"
          /> -->
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextDateOfBirthl"
          :class="{
            disable: formValidate.dayOfBirth,
            disable: formValidate.monthOfBirth,
            disable: formValidate.yearOfBirth,
          }"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <!-- <div v-else-if="step == 'question_career'" class="center career-container">
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("career") }}
        </div>
        <div class="center mt-40">
          <el-select
            v-model="form.career"
            :class="{ validate: formValidate.career }"
            class="white-57 width-250 fc-000000"
            :placeholder="$t('career')"
          >
            <el-option
              class="color-ECF5CA"
              v-for="item in options.career"
              :key="item"
              :label="$t(item)"
              :value="item"
            />
          </el-select>
          <div
            v-if="form.career == 'อื่นๆ'"
            class="white-57 width-250 m-auto mt-20"
          >
            <el-input
              @keyup="checkCareerValidate"
              v-model="form.careerInput"
              :class="{ validate: formValidate.careerInput }"
              class="white-57 mt-20 fc-000000"
              :placeholder="$t('specify')"
            />
            <div
              v-if="formValidate.careerInput"
              class="fc-F02727 fs-16 fw-500 mt-20"
            >
              {{ $t("pleaseFill") }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextCareerForm"
          style="width: 14rem"
          :class="`btn-48 btn-question btn mx-auto ${
            formValidate.career ? 'disable' : ''
          } ${formValidate.careerInput ? 'disable' : ''}`"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div> -->
    <div
      v-else-if="step == 'question_body_details'"
      class="center body-details-container"
    >
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("bodyDetail") }}
        </div>
        <!-- <div class="image-middle flex-mid mx-auto">
          <img
            src="@/assets/image/Question/body_details.gif"
            alt=""
            class="mx-auto"
            style="width: 100%; height: 100%; object-fit: scale-down"
          />
        </div> -->
        <div class="body">
          <div class="flex-center relative mt-30">
            <div class="fc-545454 fs-16 fw-500">{{ $t("height") }}</div>
            <div class="white-41 width-160 ml-auto">
              <el-input
                @keyup="checkHeightValidate"
                @change="checkHeightValidate"
                v-model="form.height"
                :class="{ validate: formValidate.height }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("centimeter") }}</div>
          </div>
          <div class="flex-center relative mt-30">
            <div class="fc-545454 fs-16 fw-500">{{ $t("weight") }}</div>
            <div class="white-41 width-160 ml-auto">
              <el-input
                @keyup="checkWeightValidate"
                @change="checkWeightValidate"
                v-model="form.weight"
                :class="{ validate: formValidate.weight }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("kilogram") }}</div>
          </div>
          <div class="flex-center relative mt-30">
            <div class="fc-545454 fs-16 fw-500">BMI</div>
            <div class="white-41 width-160 ml-auto">
              <el-input v-model="bmi" placeholder=" " />
            </div>
            <div class="absolute-text" style="margin-right: -10px">
              {{ $t("kmpermg") }}
            </div>
          </div>
          <div class="flex-center relative mt-30">
            <div class="fc-545454 fs-16 fw-500">{{ $t("waistline") }}</div>
            <div class="white-41 width-160 ml-auto">
              <el-input
                v-model="form.waistline"
                @keyup="checkWaistlineValidate"
                @change="checkWaistlineValidate"
                :class="{ validate: formValidate.waistline }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("inch") }}</div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextBodyDetail"
          :class="{
            disable: formValidate.height,
            disable: formValidate.weight,
            disable: formValidate.waistline,
          }"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_health'"
      class="center health-details-container"
    >
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("healthdetail") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6">{{ $t("optional") }}</div>

        <div class="body">
          <div class="fs-16 fw-500 fc-545454 mt-36 left">
            {{ $t("bloodpressure") }}
          </div>
          <div class="flex-center relative mt-24">
            <div class="fc-545454 fs-14 fw-500 left">
              <div>{{ $t("sbp") }}</div>
            </div>
            <div class="white-63 width-150 ml-auto">
              <el-input
                @keyup="checkBloodPressureHeight"
                @change="checkBloodPressureHeight"
                v-model="form.bloodPressureHigher"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("mmhg") }}</div>
          </div>
          <div class="flex-center relative mt-24">
            <div class="fc-545454 fs-14 fw-500 left">
              <div>{{ $t("dbp") }}</div>
            </div>
            <div class="white-63 width-150 ml-auto">
              <el-input
                @keyup="checkBloodPressureLow"
                @change="checkBloodPressureLow"
                v-model="form.bloodPressureLower"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("mmhg") }}</div>
          </div>
          <div class="fs-16 fw-500 fc-545454 mt-26 left">
            {{ $t("cholesterol") }}
          </div>
          <div class="relative mt-12">
            <div class="white-41">
              <el-input
                @keyup="checkCholesterol"
                @change="checkCholesterol"
                v-model="form.cholesterol"
                placeholder=" "
              />
            </div>
            <div class="absolute-text">{{ $t("mgdl") }}</div>
          </div>
          <div class="fs-16 fw-500 fc-545454 mt-26 left">
            {{ $t("bloodsugar") }}
          </div>
          <div class="relative mt-12">
            <div class="white-41">
              <el-input
                @keyup="checkBloodGlucose"
                @change="checkBloodGlucose"
                v-model="form.bloodSugar"
                placeholder=" "
              />
            </div>
            <div class="absolute-text">{{ $t("mgdl") }}</div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextHealthDetail"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_behavior'"
      class="center behavior-container"
    >
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("behavior") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6">{{ $t("morethanone") }}</div>

        <div class="behavior-container DBAdmanX">
          <div class="body">
            <div
              :class="`disease-long-card  ${
                form.behavior.snoring == true ? 'select' : ''
              }`"
              @click="form.behavior.snoring = !form.behavior.snoring"
            >
              <div class="icon">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 15.662C22.9197 15.9894 21.7735 16.1655 20.5863 16.1655C14.0959 16.1655 8.8345 10.9041 8.8345 4.41375C8.8345 3.22648 9.01057 2.08034 9.33801 1C4.51257 2.46255 1 6.9452 1 12.2482C1 18.7386 6.26144 24 12.7518 24C18.0548 24 22.5374 20.4874 24 15.662Z"
                    :stroke="
                      form.behavior.snoring == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("snoring") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="`disease-long-card ${
                form.behavior.alcohol == true ? 'select' : ''
              }`"
              @click="form.behavior.alcohol = !form.behavior.alcohol"
            >
              <div class="icon">
                <svg
                  width="29"
                  height="31"
                  viewBox="0 0 29 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.8743 13.7781C10.5535 13.7781 10.2935 14.0193 10.2935 14.3168V22.5326C10.2935 22.8301 10.5535 23.0713 10.8743 23.0713C11.195 23.0713 11.4551 22.8301 11.4551 22.5326V14.3168C11.4551 14.0193 11.195 13.7781 10.8743 13.7781Z"
                    :fill="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    :stroke="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="0.8"
                  />
                  <path
                    d="M17.4568 13.7781C17.136 13.7781 16.876 14.0193 16.876 14.3168V22.5326C16.876 22.8301 17.136 23.0713 17.4568 23.0713C17.7778 23.0713 18.0376 22.8301 18.0376 22.5326V14.3168C18.0376 14.0193 17.7776 13.7781 17.4568 13.7781Z"
                    :fill="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    :stroke="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="0.8"
                  />
                  <path
                    d="M25.2082 10.9139H23.1856V8.39276C23.2221 8.36198 23.2531 8.32861 23.2869 8.29503C23.871 7.70605 24.2004 6.91405 24.205 6.08761C24.2097 5.26103 23.8889 4.4656 23.3112 3.87022C22.7336 3.27504 21.9447 2.92709 21.1125 2.90074L20.9971 2.89514C20.1001 2.87016 19.2093 2.73706 18.3445 2.49863C17.8891 2.34814 17.4467 2.16047 17.0225 1.93742C16.4897 1.65783 15.9312 1.42959 15.3543 1.25635C14.1388 0.889611 12.8372 0.916994 11.6386 1.33449C10.9522 1.63207 10.3355 2.06734 9.82702 2.61315C9.53023 2.91433 9.20424 3.18556 8.85368 3.42295C8.5436 3.56145 8.20049 3.61082 7.86344 3.56524L7.77907 3.56245H7.77927C6.77393 3.54466 5.80445 3.93258 5.09266 4.63748C5.01393 4.71283 4.94084 4.79097 4.87037 4.87211L4.87057 4.87191C4.85607 4.86651 4.84097 4.86291 4.82567 4.86071C4.58445 4.80116 4.33699 4.77118 4.08852 4.77138C3.26981 4.77278 2.48498 5.09614 1.90607 5.67072C1.32721 6.24548 1.00139 7.02454 1 7.83715C1 7.89851 1.00282 7.96286 1.00564 8.02142L1 8.02702V14.1891V14.1889C1.0006 14.807 1.22853 15.4038 1.64092 15.8668C2.05328 16.3301 2.62189 16.6279 3.23987 16.7044C3.8578 16.7812 4.48279 16.6313 4.99727 16.2829V25.0891C4.99867 26.2994 5.48373 27.4598 6.34591 28.3155C7.20811 29.1713 8.37712 29.6527 9.59633 29.6541H18.5864C19.8056 29.6527 20.9746 29.1713 21.8368 28.3155C22.699 27.4597 23.1841 26.2994 23.1855 25.0891V23.3469H25.208C25.9758 23.3467 26.7123 23.0441 27.2556 22.5054C27.7986 21.9668 28.1043 21.2361 28.1052 20.474V13.7871C28.1038 13.025 27.798 12.2945 27.255 11.756C26.7119 11.2176 25.9758 10.9146 25.208 10.914L25.2082 10.9139ZM22.0605 25.0891C22.0595 26.0034 21.6932 26.8798 21.0418 27.5263C20.3905 28.1726 19.5075 28.5364 18.5866 28.5374H9.59648C8.67551 28.5364 7.79259 28.1726 7.1412 27.5263C6.48982 26.8798 6.12359 26.0034 6.12256 25.0891V10.8193C6.94688 11.1962 7.85253 11.171 8.60644 11.1488C9.50787 11.128 10.4073 11.2399 11.2757 11.481C11.8518 11.6555 12.4488 11.7532 13.0509 11.7714C13.2935 11.773 13.5359 11.7496 13.7737 11.7016C14.9242 11.4588 15.4191 10.582 15.8524 9.80859C16.1983 9.19162 16.4996 8.66101 17.0734 8.46C17.785 8.20878 18.3419 8.4488 19.0481 8.75038C19.6484 9.05516 20.3072 9.22924 20.9804 9.26141C21.3485 9.26121 21.7138 9.19886 22.0607 9.07715L22.0605 25.0891ZM22.4825 7.51619C22.0881 7.9189 21.546 8.14554 20.9802 8.14432C20.4614 8.10794 19.9557 7.96545 19.4951 7.72562C18.713 7.39066 17.8269 7.00816 16.6991 7.40725C15.723 7.7506 15.2701 8.55202 14.8707 9.26108C14.4486 10.0121 14.1589 10.4756 13.5402 10.6069C12.9156 10.741 12.2237 10.5789 11.5712 10.4031C10.6871 10.1594 9.77413 10.0337 8.85657 10.0289C8.76093 10.0289 8.66811 10.0289 8.57246 10.0317C8.1011 10.0637 7.62773 10.0461 7.16001 9.97918C6.93671 9.943 6.72046 9.87285 6.51852 9.77113C6.29825 9.65361 6.12186 9.46035 5.90317 9.34684C5.69175 9.2599 5.45094 9.27889 5.25601 9.398C5.08909 9.51711 4.98902 9.70777 4.986 9.91183V14.1277C4.99244 14.4879 4.86438 14.8378 4.62659 15.11C4.38879 15.3822 4.05778 15.5573 3.69758 15.6019C3.29589 15.6404 2.8962 15.5093 2.59698 15.2403C2.29777 14.9715 2.12642 14.5898 2.12522 14.1891V7.78964C2.13126 7.50525 2.20133 7.22567 2.33059 6.97165C2.5702 6.4922 2.99708 6.13105 3.51192 5.97218C3.86388 5.87026 4.23717 5.86646 4.59098 5.96139C4.804 6.02035 5.03052 6.00976 5.23689 5.93121C5.43583 5.85587 5.61262 5.73216 5.75115 5.57168C6.18385 5.08383 6.78123 4.77006 7.43102 4.68912C7.75258 4.64655 8.06787 4.69692 8.38884 4.67733C8.76738 4.66534 9.13667 4.55741 9.46146 4.36396C9.87241 4.08716 10.2548 3.77119 10.6035 3.42026C11.0082 2.97998 11.4979 2.62483 12.0436 2.37603C13.1182 1.96273 14.2772 2.12481 15.059 2.33406H15.0592C15.5664 2.48815 16.0573 2.6912 16.5247 2.94003C17.0043 3.18985 17.5038 3.3999 18.0184 3.56816C18.9741 3.83156 19.9581 3.98066 20.9495 4.01203L21.0818 4.01763H21.0816C21.6206 4.03642 22.131 4.26325 22.5041 4.64975C22.8772 5.03627 23.0838 5.5519 23.0798 6.08732C23.0758 6.62253 22.8615 7.13513 22.4826 7.51609L22.4825 7.51619ZM26.9803 20.4742C26.9793 20.9402 26.7922 21.3867 26.46 21.7159C26.1278 22.0453 25.6775 22.2301 25.2082 22.2305H23.1856V12.0313H25.2082C25.6774 12.0321 26.1274 12.2171 26.4594 12.5463C26.7914 12.8754 26.9786 13.3217 26.9802 13.7874L26.9803 20.4742Z"
                    :fill="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    :stroke="
                      form.behavior.alcohol == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="0.8"
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("alcohol") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="`disease-long-card ${
                form.behavior.healthCheck == true ? 'select' : ''
              }`"
              @click="form.behavior.healthCheck = !form.behavior.healthCheck"
            >
              <div class="icon">
                <svg
                  width="23"
                  height="32"
                  viewBox="0 0 23 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.78498 31.3599H22.0148C22.4468 31.3599 22.8002 31.0066 22.8002 30.5746L22.7999 1.78539C22.7999 1.35339 22.4465 1 22.0145 1H1.78539C1.35339 1 1 1.35339 1 1.78539V30.5826C1 31.0065 1.35339 31.3599 1.78539 31.3599L1.78498 31.3599ZM8.7975 2.57078H15.0094V3.33248H8.7975V2.57078ZM2.56984 2.57078H7.22672V4.11787C7.22672 4.54988 7.58011 4.90326 8.01211 4.90326H15.7947C16.2267 4.90326 16.5801 4.54988 16.5801 4.11787V2.57078H21.237V29.797H2.5701L2.56984 2.57078Z"
                    :fill="
                      form.behavior.healthCheck == true ? '#206B5E' : '#206B5E'
                    "
                    :stroke="
                      form.behavior.healthCheck == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="0.4"
                  />
                  <path
                    d="M18.9046 15.7798H17.7658L16.4464 13.7931C16.2815 13.5496 15.9989 13.416 15.7004 13.4476C15.4099 13.4789 15.1585 13.6753 15.0565 13.95L13.4702 18.1907L11.083 11.6254C10.9731 11.3112 10.6747 11.1072 10.345 11.1072H10.3371C9.99948 11.1151 9.70893 11.327 9.59901 11.6412L7.76921 17.1227L7.10162 16.1254C6.95254 15.9056 6.70906 15.772 6.4498 15.772H4.89477C4.46276 15.772 4.10938 16.1254 4.10938 16.5574C4.10938 16.9894 4.46276 17.3428 4.89477 17.3428H6.03354L7.36059 19.3295C7.52545 19.5809 7.82389 19.7142 8.11442 19.675C8.41285 19.6358 8.66421 19.4315 8.75834 19.1489L10.3762 14.2801L12.7163 20.7197C12.8262 21.026 13.1247 21.2379 13.4544 21.2379C13.7841 21.2379 14.0747 21.0336 14.1925 20.7276L15.9907 15.9371L16.6975 16.9973C16.8466 17.2171 17.09 17.3507 17.3493 17.3507H18.9043C19.3363 17.3507 19.6897 16.9973 19.6897 16.5653C19.69 16.1333 19.3366 15.7799 18.9046 15.7799L18.9046 15.7798Z"
                    :fill="
                      form.behavior.healthCheck == true ? '#206B5E' : '#206B5E'
                    "
                    :stroke="
                      form.behavior.healthCheck == true ? '#206B5E' : '#206B5E'
                    "
                    stroke-width="0.4"
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("healthcheck") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="`disease-long-card ${
                form.behavior.nothealthCheck == true ? 'select' : ''
              }`"
              @click="
                form.behavior.nothealthCheck = !form.behavior.nothealthCheck
              "
            >
              <div class="icon">
                <svg
                  width="38"
                  height="35"
                  viewBox="0 0 38 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.73967 32.6072H28.8017C29.2087 32.6072 29.5417 32.2742 29.5417 31.8672L29.5415 4.73993C29.5415 4.33286 29.2085 3.99988 28.8014 3.99988H9.74005C9.33299 3.99988 9 4.33286 9 4.73993V31.8748C9 32.2742 9.33299 32.6072 9.74005 32.6072L9.73967 32.6072ZM16.3474 5.47998H22.2006V6.19771H16.3474V5.47998ZM10.4792 5.47998H14.8673V6.93776C14.8673 7.34483 15.2003 7.67782 15.6073 7.67782H22.9406C23.3477 7.67782 23.6807 7.34483 23.6807 6.93776V5.47998H28.0687V31.1345H10.4795L10.4792 5.47998Z"
                    :fill="
                      form.behavior.nothealthCheck == true
                        ? '#206B5E'
                        : '#206B5E'
                    "
                    :stroke="
                      form.behavior.nothealthCheck == true
                        ? '#206B5E'
                        : '#206B5E'
                    "
                    stroke-width="0.4"
                  />
                  <path
                    d="M25.8708 17.9265H24.7978L23.5545 16.0544C23.3992 15.825 23.1328 15.6991 22.8516 15.7288C22.5779 15.7583 22.341 15.9434 22.2449 16.2023L20.7502 20.1981L18.5008 14.0119C18.3972 13.7158 18.116 13.5236 17.8053 13.5236H17.7979C17.4798 13.531 17.206 13.7307 17.1024 14.0268L15.3783 19.1918L14.7492 18.2521C14.6087 18.0449 14.3793 17.9191 14.135 17.9191H12.6697C12.2627 17.9191 11.9297 18.2521 11.9297 18.6591C11.9297 19.0662 12.2627 19.3992 12.6697 19.3992H13.7428L14.9932 21.2713C15.1486 21.5081 15.4298 21.6337 15.7035 21.5968C15.9847 21.5599 16.2216 21.3674 16.3103 21.1011L17.8347 16.5133L20.0398 22.5812C20.1434 22.8698 20.4246 23.0695 20.7353 23.0695C21.0459 23.0695 21.3197 22.877 21.4307 22.5886L23.1251 18.0747L23.7911 19.0737C23.9316 19.2808 24.161 19.4066 24.4053 19.4066H25.8706C26.2776 19.4066 26.6106 19.0737 26.6106 18.6666C26.6109 18.2595 26.2779 17.9265 25.8708 17.9265L25.8708 17.9265Z"
                    :fill="
                      form.behavior.nothealthCheck == true
                        ? '#206B5E'
                        : '#206B5E'
                    "
                    :stroke="
                      form.behavior.nothealthCheck == true
                        ? '#206B5E'
                        : '#206B5E'
                    "
                    stroke-width="0.4"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M36.8132 1.25878C37.2226 1.70771 37.1905 2.40345 36.7415 2.81276L2.74153 33.8128C2.2926 34.2221 1.59686 34.19 1.18755 33.741C0.778232 33.2921 0.810343 32.5964 1.25927 32.1871L35.2593 1.18706C35.7082 0.777744 36.4039 0.809855 36.8132 1.25878Z"
                    :fill="
                      form.behavior.nothealthCheck == true
                        ? '#206B5E'
                        : '#206B5E'
                    "
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("nothealthcheck") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              :class="`disease-long-card ${
                form.behavior.smoking == true ? 'select' : ''
              }`"
              @click="form.behavior.smoking = !form.behavior.smoking"
            >
              <div class="icon">
                <svg
                  width="28"
                  viewBox="0 0 40 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 25.5757C1 26.6415 1.42338 27.6638 2.17707 28.4174C2.93052 29.1709 3.95297 29.5945 5.01877 29.5945H34.5588C34.9984 29.5945 35.42 29.4197 35.7307 29.109C36.0416 28.7983 36.2162 28.3767 36.2162 27.9371V23.214C36.2162 22.7744 36.0416 22.3531 35.7307 22.0421C35.42 21.7314 34.9984 21.5569 34.5588 21.5569H5.01877C3.95297 21.5569 2.93044 21.9803 2.17707 22.734C1.42333 23.4874 1 24.5099 1 25.5757V25.5757ZM2.65708 25.5757C2.65708 24.9492 2.9059 24.3486 3.34865 23.9056C3.79168 23.4629 4.39218 23.2141 5.01875 23.2141H10.5288V27.9372H5.01875C4.3922 27.9372 3.79166 27.6883 3.34865 27.2456C2.9059 26.8025 2.65708 26.202 2.65708 25.5758V25.5757ZM12.1861 23.214H30.0013V27.9371H12.1861V23.214ZM34.5586 27.8958H31.6586V23.214H34.5586V27.8958Z"
                    :fill="form.smoking == true ? '#206B5E' : '#206B5E'"
                    :stroke="form.smoking == true ? '#206B5E' : '#206B5E'"
                    stroke-width="0.3"
                  />
                  <path
                    d="M28.5095 18.1178C28.5095 18.5753 28.8802 18.9464 29.338 18.9464C29.7955 18.9464 30.1665 18.5753 30.1665 18.1178C30.1665 16.6676 30.7879 15.9634 31.6167 15.0935C32.4453 14.2233 33.4811 13.0633 33.4811 10.9504C33.4811 8.83752 32.4866 7.76017 31.6167 6.80734C30.7466 5.85451 30.1665 5.27449 30.1665 3.78298V3.78269C30.1535 3.2703 30.2527 2.76136 30.4567 2.29119C30.5934 2.08803 30.6333 1.83487 30.5654 1.59962C30.4977 1.36438 30.3295 1.17104 30.1056 1.07162C29.8819 0.971917 29.6255 0.976541 29.4056 1.08405C29.1854 1.19156 29.0241 1.39068 28.9652 1.62852C28.6591 2.30506 28.5037 3.04027 28.5094 3.78269C28.5094 5.89558 29.5038 6.97292 30.3737 7.92575C31.2439 8.87858 31.824 9.45861 31.824 10.9501C31.824 12.4416 31.2026 13.1046 30.3737 13.9745C29.5452 14.8447 28.5094 16.0046 28.5094 18.1178L28.5095 18.1178Z"
                    :fill="form.smoking == true ? '#206B5E' : '#206B5E'"
                    :stroke="form.smoking == true ? '#206B5E' : '#206B5E'"
                    stroke-width="0.3"
                  />
                  <path
                    d="M34.2341 18.2346C34.2341 18.6921 34.6048 19.0632 35.0626 19.0632C35.5201 19.0632 35.8911 18.6921 35.8911 18.2346C35.8911 16.7844 36.5125 16.0802 37.3414 15.2103C38.1699 14.3401 39.2057 13.1801 39.2057 11.0672C39.2057 8.95434 38.2113 7.87699 37.3414 6.92416C36.4712 5.97134 35.8911 5.39131 35.8911 3.89981V3.89952C35.8781 3.38712 35.9773 2.87818 36.1813 2.40802C36.318 2.20485 36.3579 1.95169 36.29 1.71644C36.2223 1.4812 36.0541 1.28786 35.8302 1.18845C35.6065 1.08874 35.3501 1.09336 35.1302 1.20087C34.91 1.30838 34.7488 1.5075 34.6898 1.74535C34.3837 2.42188 34.2283 3.15709 34.234 3.89951C34.234 6.0124 35.2285 7.08974 36.0983 8.04257C36.9685 8.9954 37.5486 9.57543 37.5486 11.0669C37.5486 12.5584 36.9272 13.2214 36.0983 14.0913C35.2698 14.9615 34.234 16.1215 34.234 18.2346L34.2341 18.2346Z"
                    :fill="form.smoking == true ? '#206B5E' : '#206B5E'"
                    :stroke="form.smoking == true ? '#206B5E' : '#206B5E'"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("smoking") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="body mt-36">
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.snoring ? 'select' : ''
            }`"
            @click="form.behavior.snoring = !form.behavior.snoring"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.2841 14.5681C21.2843 14.8711 20.2237 15.0341 19.125 15.0341C13.1189 15.0341 8.25 10.1652 8.25 4.15906C8.25 3.06037 8.41293 1.99974 8.71594 1C4.25051 2.35344 1 6.50165 1 11.4091C1 17.4152 5.8689 22.2841 11.875 22.2841C16.7824 22.2841 20.9306 19.0336 22.2841 14.5681Z"
                    stroke="#206B5E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("snoring") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.alcohol ? 'select' : ''
            }`"
            @click="form.behavior.alcohol = !form.behavior.alcohol"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="27"
                  height="29"
                  viewBox="0 0 27 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3041 13.0405C10.0018 13.0405 9.75677 13.2678 9.75677 13.5481V21.2897C9.75677 21.57 10.0018 21.7973 10.3041 21.7973C10.6063 21.7973 10.8514 21.57 10.8514 21.2897V13.5481C10.8514 13.2678 10.6063 13.0405 10.3041 13.0405Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                  <path
                    d="M16.5067 13.0405C16.2045 13.0405 15.9594 13.2678 15.9594 13.5481V21.2897C15.9594 21.57 16.2045 21.7973 16.5067 21.7973C16.8092 21.7973 17.054 21.57 17.054 21.2897V13.5481C17.054 13.2678 16.809 13.0405 16.5067 13.0405Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                  <path
                    d="M23.8107 10.3416H21.9049V7.966C21.9393 7.937 21.9685 7.90555 22.0003 7.87391C22.5507 7.31892 22.8612 6.57264 22.8655 5.79392C22.8698 5.01505 22.5676 4.26554 22.0233 3.70453C21.4789 3.14371 20.7356 2.81584 19.9515 2.79101L19.8427 2.78574C18.9975 2.7622 18.1581 2.63678 17.3433 2.41212C16.9141 2.27031 16.4973 2.09348 16.0976 1.88331C15.5955 1.61986 15.0692 1.40479 14.5257 1.24155C13.3803 0.895984 12.1539 0.921785 11.0245 1.31518C10.3777 1.59558 9.79656 2.00573 9.31746 2.52002C9.0378 2.80382 8.73064 3.05939 8.40031 3.28308C8.10813 3.41358 7.78483 3.4601 7.46723 3.41716L7.38773 3.41452H7.38792C6.44061 3.39776 5.52711 3.76329 4.8564 4.4275C4.78222 4.4985 4.71335 4.57213 4.64694 4.64858L4.64713 4.64839C4.63347 4.64331 4.61924 4.63992 4.60482 4.63785C4.37753 4.58173 4.14436 4.55348 3.91022 4.55367C3.13878 4.55499 2.39926 4.85969 1.85377 5.40109C1.30832 5.94267 1.00131 6.67676 1 7.44246C1 7.50028 1.00266 7.56091 1.00531 7.61609L1 7.62137V13.4277V13.4275C1.00057 14.01 1.21534 14.5723 1.60392 15.0086C1.99248 15.4451 2.52826 15.7257 3.11057 15.7979C3.69282 15.8702 4.28174 15.7289 4.76651 15.4007V23.6985C4.76784 24.8389 5.22489 25.9323 6.0373 26.7387C6.84973 27.545 7.95126 27.9987 9.10008 28H17.5712C18.72 27.9987 19.8215 27.545 20.634 26.7387C21.4464 25.9323 21.9035 24.8389 21.9048 23.6985V22.0569H23.8106C24.534 22.0567 25.228 21.7716 25.7399 21.2639C26.2516 20.7564 26.5396 20.0679 26.5405 19.3499V13.0489C26.5392 12.3308 26.251 11.6425 25.7393 11.135C25.2276 10.6277 24.534 10.3422 23.8106 10.3417L23.8107 10.3416ZM20.8447 23.6985C20.8438 24.56 20.4987 25.3858 19.8849 25.995C19.2711 26.604 18.4391 26.9468 17.5713 26.9477H9.10023C8.23243 26.9468 7.40047 26.604 6.78669 25.995C6.17291 25.3858 5.82782 24.56 5.82685 23.6985V10.2524C6.60358 10.6076 7.45696 10.5839 8.16734 10.563C9.01674 10.5434 9.86429 10.6488 10.6825 10.8759C11.2254 11.0403 11.7879 11.1324 12.3552 11.1496C12.5838 11.1511 12.8123 11.129 13.0363 11.0838C14.1204 10.855 14.5868 10.0289 14.995 9.3001C15.321 8.71874 15.6048 8.21877 16.1456 8.02935C16.8161 7.79263 17.3408 8.0188 18.0062 8.30298C18.5718 8.59016 19.1926 8.75419 19.827 8.78451C20.1739 8.78432 20.518 8.72556 20.8449 8.61088L20.8447 23.6985ZM21.2424 7.14003C20.8707 7.51949 20.36 7.73305 19.8268 7.73189C19.3379 7.69762 18.8615 7.56335 18.4274 7.33737C17.6905 7.02175 16.8555 6.66133 15.7929 7.03738C14.8731 7.36091 14.4464 8.11606 14.0699 8.78419C13.6723 9.4919 13.3992 9.92858 12.8163 10.0523C12.2277 10.1787 11.5758 10.026 10.9609 9.86025C10.1279 9.63069 9.26763 9.51224 8.40303 9.50772C8.31291 9.50772 8.22545 9.50772 8.13533 9.51036C7.69118 9.54049 7.24513 9.52392 6.80441 9.46083C6.594 9.42675 6.39024 9.36065 6.19995 9.2648C5.99239 9.15406 5.82619 8.97196 5.62012 8.865C5.42091 8.78308 5.194 8.80097 5.01033 8.91321C4.85304 9.02544 4.75875 9.2051 4.7559 9.39737V13.3699C4.76197 13.7093 4.6413 14.039 4.41724 14.2955C4.19317 14.552 3.88126 14.7169 3.54186 14.7589C3.16335 14.7953 2.78674 14.6717 2.50479 14.4183C2.22285 14.165 2.0614 13.8053 2.06026 13.4277V7.39769C2.06595 7.12972 2.13198 6.86628 2.25378 6.62692C2.47956 6.17515 2.88179 5.83484 3.36691 5.68515C3.69855 5.58911 4.05029 5.58554 4.38368 5.67499C4.58441 5.73054 4.79785 5.72056 4.99231 5.64655C5.17976 5.57555 5.34634 5.45899 5.47688 5.30777C5.8846 4.84808 6.4475 4.55243 7.05978 4.47616C7.36277 4.43605 7.65986 4.4835 7.96231 4.46505C8.31899 4.45375 8.66696 4.35205 8.973 4.16977C9.36024 3.90894 9.72054 3.61121 10.0491 3.28055C10.4305 2.86568 10.8919 2.53104 11.4061 2.29659C12.4187 1.90716 13.5107 2.05988 14.2474 2.25705H14.2476C14.7255 2.40224 15.1881 2.59357 15.6285 2.82804C16.0804 3.06343 16.5511 3.26136 17.036 3.4199C17.9365 3.6681 18.8637 3.80859 19.7979 3.83816L19.9225 3.84343H19.9223C20.4302 3.86113 20.9112 4.07487 21.2628 4.43906C21.6143 4.80326 21.809 5.28913 21.8052 5.79364C21.8014 6.29796 21.5995 6.78097 21.2425 7.13993L21.2424 7.14003ZM25.4805 19.35C25.4796 19.7892 25.3033 20.2099 24.9903 20.52C24.6772 20.8304 24.253 21.0046 23.8107 21.005H21.9049V11.3944H23.8107C24.2528 11.3952 24.6768 11.5696 24.9897 11.8797C25.3025 12.1899 25.479 12.6104 25.4805 13.0492L25.4805 19.35Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("alcohol") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
         <div
            :class="`behavior-card flex-mid ${
              form.behavior.exercise ? 'select' : ''
            }`"
            @click="form.behavior.exercise = !form.behavior.exercise"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="34"
                  height="16"
                  viewBox="0 0 34 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M31.7202 4.18166H30.4401V3.54538C30.4401 2.14526 29.288 1 27.8802 1H25.3202C23.9121 1 22.7603 2.14553 22.7603 3.54538V5.45448H11.2402V3.54538C11.2402 2.14526 10.0882 1 8.68032 1H6.12039C4.71227 1 3.56047 2.14553 3.56047 3.54538V4.18166H2.2801C1.57614 4.18166 1 4.75428 1 5.45448V10.5455C1 11.2455 1.57589 11.8183 2.2801 11.8183H3.5602V12.4546C3.5602 13.8547 4.71227 15 6.12012 15H8.68004C10.0882 15 11.24 13.8545 11.24 12.4546V10.5455H22.76V12.4546C22.76 13.8547 23.9121 15 25.32 15H27.8799C29.288 15 30.4398 13.8545 30.4398 12.4546V11.8183H31.7199C32.4239 11.8183 33 11.2457 33 10.5455V5.45448C33.0003 4.75425 32.4244 4.18166 31.7205 4.18166H31.7202ZM2.27955 10.5452V5.45421H3.55965V10.5452H2.27955ZM9.95959 12.4543C9.95959 13.1543 9.3837 13.7272 8.6795 13.7272H6.11957C5.41561 13.7272 4.83947 13.1546 4.83947 12.4543V3.54497C4.83947 2.84501 5.41537 2.27214 6.11957 2.27214H8.6795C9.38345 2.27214 9.95959 2.84477 9.95959 3.54497V12.4543ZM11.2397 9.27269V6.72731H22.7598V9.27269H11.2397ZM29.1596 12.4543C29.1596 13.1543 28.5837 13.7272 27.8795 13.7272H25.3195C24.6156 13.7272 24.0394 13.1546 24.0394 12.4543V3.54497C24.0394 2.84501 24.6153 2.27214 25.3195 2.27214H27.8795C28.5834 2.27214 29.1596 2.84477 29.1596 3.54497V12.4543ZM30.4397 10.5452V5.45421H31.7198V10.5452H30.4397Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label">ออกกำลังกาย มากกว่า 3 ครั้ง ต่อสัปดาห์</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.healthCheck ? 'select' : ''
            }`"
            @click="form.behavior.healthCheck = !form.behavior.healthCheck"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="22"
                  height="30"
                  viewBox="0 0 22 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.73967 29.6074H20.8017C21.2087 29.6074 21.5417 29.2744 21.5417 28.8673L21.5415 1.74005C21.5415 1.33299 21.2085 1 20.8014 1H1.74005C1.33299 1 1 1.33299 1 1.74005V28.8749C1 29.2743 1.33299 29.6073 1.74005 29.6073L1.73967 29.6074ZM8.34738 2.48011H14.2006V3.19783H8.34738V2.48011ZM2.47921 2.48011H6.86727V3.93789C6.86727 4.34495 7.20025 4.67794 7.60732 4.67794H14.9406C15.3477 4.67794 15.6807 4.34495 15.6807 3.93789V2.48011H20.0687V28.1346H2.47947L2.47921 2.48011Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.4"
                  />
                  <path
                    d="M17.8708 14.9268H16.7978L15.5545 13.0548C15.3992 12.8253 15.1328 12.6995 14.8516 12.7292C14.5779 12.7587 14.341 12.9438 14.2449 13.2027L12.7502 17.1985L10.5008 11.0123C10.3972 10.7162 10.116 10.5239 9.80532 10.5239H9.79789C9.47977 10.5314 9.206 10.731 9.10242 11.0271L7.37825 16.1921L6.7492 15.2524C6.60872 15.0453 6.3793 14.9194 6.13501 14.9194H4.66974C4.26267 14.9194 3.92969 15.2524 3.92969 15.6595C3.92969 16.0666 4.26267 16.3995 4.66974 16.3995H5.74278L6.99322 18.2716C7.14856 18.5085 7.42977 18.6341 7.70353 18.5972C7.98473 18.5603 8.22159 18.3678 8.31028 18.1014L9.83472 13.5137L12.0398 19.5815C12.1434 19.8702 12.4246 20.0699 12.7353 20.0699C13.0459 20.0699 13.3197 19.8773 13.4307 19.589L15.1251 15.0751L15.7911 16.074C15.9316 16.2811 16.161 16.407 16.4053 16.407H17.8706C18.2776 16.407 18.6106 16.074 18.6106 15.667C18.6109 15.2599 18.2779 14.9269 17.8708 14.9269L17.8708 14.9268Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.4"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("healthcheck") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.smoking ? 'select' : ''
            }`"
            @click="form.behavior.smoking = !form.behavior.smoking"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="38"
                  height="29"
                  viewBox="0 0 38 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 24.1511C1 25.1554 1.39894 26.1186 2.10912 26.8288C2.81908 27.5387 3.7825 27.9379 4.78678 27.9379H32.6215C33.0357 27.9379 33.4331 27.7731 33.7258 27.4804C34.0188 27.1877 34.1833 26.7904 34.1833 26.3762V21.9257C34.1833 21.5115 34.0188 21.1145 33.7258 20.8215C33.433 20.5287 33.0357 20.3643 32.6215 20.3643H4.78678C3.7825 20.3643 2.81901 20.7632 2.10912 21.4734C1.39889 22.1833 1 23.1468 1 24.151V24.1511ZM2.56142 24.1511C2.56142 23.5607 2.79588 22.9949 3.21307 22.5774C3.63053 22.1602 4.19636 21.9258 4.78676 21.9258H9.97872V26.3762H4.78676C4.19637 26.3762 3.63051 26.1417 3.21307 25.7246C2.79588 25.3071 2.56142 24.7413 2.56142 24.1512V24.1511ZM11.5404 21.9258H28.3271V26.3762H11.5404V21.9258ZM32.6214 26.3372H29.8887V21.9258H32.6214V26.3372Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                  <path
                    d="M26.9218 17.1238C26.9218 17.5549 27.2712 17.9045 27.7025 17.9045C28.1336 17.9045 28.4832 17.5549 28.4832 17.1238C28.4832 15.7573 29.0687 15.0937 29.8497 14.274C30.6304 13.4541 31.6064 12.3611 31.6064 10.3701C31.6064 8.37922 30.6694 7.36407 29.8497 6.46624C29.0298 5.56842 28.4832 5.02187 28.4832 3.61647V3.6162C28.471 3.13338 28.5644 2.65382 28.7566 2.2108C28.8854 2.01936 28.923 1.78081 28.859 1.55915C28.7953 1.33748 28.6368 1.1553 28.4258 1.06163C28.215 0.967679 27.9735 0.972036 27.7662 1.07334C27.5587 1.17464 27.4068 1.36226 27.3512 1.58638C27.0628 2.22387 26.9163 2.91663 26.9218 3.6162C26.9218 5.60711 27.8588 6.62226 28.6785 7.52009C29.4984 8.41791 30.045 8.96446 30.045 10.3699C30.045 11.7753 29.4595 12.4 28.6785 13.2196C27.8978 14.0396 26.9218 15.1326 26.9218 17.1238L26.9218 17.1238Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                  <path
                    d="M32.3154 17.2337C32.3154 17.6647 32.6648 18.0144 33.0961 18.0144C33.5272 18.0144 33.8768 17.6647 33.8768 17.2337C33.8768 15.8672 34.4623 15.2036 35.2433 14.3839C36.024 13.5639 37 12.4709 37 10.48C37 8.48908 36.063 7.47393 35.2433 6.57611C34.4234 5.67828 33.8768 5.13174 33.8768 3.72633V3.72606C33.8646 3.24325 33.958 2.76368 34.1502 2.32066C34.279 2.12922 34.3166 1.89067 34.2526 1.66901C34.1889 1.44735 34.0304 1.26517 33.8194 1.17149C33.6086 1.07754 33.3671 1.0819 33.1598 1.1832C32.9523 1.2845 32.8004 1.47213 32.7448 1.69624C32.4565 2.33373 32.3099 3.0265 32.3154 3.72606C32.3154 5.71697 33.2524 6.73213 34.0721 7.62995C34.892 8.52778 35.4386 9.07432 35.4386 10.4797C35.4386 11.8851 34.8531 12.5098 34.0721 13.3295C33.2914 14.1495 32.3154 15.2425 32.3154 17.2337L32.3154 17.2337Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("smoking") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextBehavior"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_disease'"
      class="center disease-container"
    >
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("disease") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6">
          {{ $t("morethanonedisease") }}
        </div>
        <div class="body mt-4 pt-34">
          <div
            :class="`disease-long-card ${form.disease.cancer ? 'select' : ''}`"
            @click="
              form.disease.cancer = !form.disease.cancer;
              form.disease.none = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.7946 15.293H34.2945C33.961 14.0831 33.478 12.9246 32.858 11.8301L33.2128 11.4711C33.978 10.7059 34.4012 9.68831 34.4012 8.60667C34.4012 7.52503 33.978 6.50752 33.2128 5.74224C31.6353 4.16467 29.0616 4.16047 27.4841 5.74224L27.125 6.09712C26.0306 5.47713 24.8678 4.99403 23.6621 4.66063V4.16052C23.6621 1.92448 21.8451 0.107422 19.609 0.107422C17.3775 0.107422 15.5559 1.92448 15.5559 4.16052V4.66063C14.3502 4.99404 13.1875 5.47713 12.0931 6.09712L11.7382 5.74224C10.1564 4.16047 7.58698 4.16047 6.0049 5.74224C4.42733 7.31982 4.42733 9.89345 6.0049 11.471L6.36395 11.8301C5.73978 12.9245 5.25666 14.0873 4.92327 15.293H4.42315C2.18742 15.293 0.370361 17.11 0.370361 19.3461C0.370361 21.5776 2.18742 23.3991 4.42346 23.3991H4.92357C5.25698 24.6048 5.74007 25.7676 6.36426 26.862L6.00521 27.2169C4.42764 28.7987 4.42764 31.3681 6.00521 32.9502C7.58698 34.5278 10.1564 34.5278 11.7385 32.9502L12.0934 32.5911C13.1878 33.2153 14.3505 33.6984 15.5562 34.0318V34.5319C15.5562 36.768 17.3774 38.585 19.6093 38.585C21.8454 38.585 23.6624 36.768 23.6624 34.5319V34.0318C24.8681 33.6984 26.0309 33.2153 27.1253 32.5911L27.4844 32.9502C29.0619 34.5278 31.6356 34.5278 33.2132 32.9502C34.7949 31.3684 34.7949 28.799 33.2132 27.2169L32.8583 26.862C33.4783 25.7676 33.9614 24.6048 34.2948 23.3991H34.7949C37.0309 23.3991 38.848 21.578 38.848 19.3461C38.8477 17.11 37.0306 15.293 34.7946 15.293ZM34.7946 21.6889H33.6273C33.2298 21.6889 32.8836 21.9627 32.7935 22.3515C32.4556 23.8352 31.8744 25.2415 31.0579 26.537C30.8441 26.8749 30.8912 27.315 31.1733 27.5972L32.0027 28.4265C32.9176 29.3414 32.9176 30.8248 32.0027 31.7397C31.0919 32.6505 29.6044 32.6505 28.6936 31.7397L27.8643 30.9104C27.5822 30.6283 27.1417 30.577 26.8041 30.7908C25.5045 31.6073 24.0978 32.193 22.6186 32.5309C22.2294 32.6165 21.9518 32.9627 21.9518 33.3647V34.5319C21.9518 35.8229 20.9 36.8748 19.6089 36.8748C18.3179 36.8748 17.2661 35.823 17.2661 34.5319V33.3647C17.2661 32.9627 16.9923 32.6165 16.6035 32.5309C15.1198 32.193 13.7135 31.6073 12.418 30.7908C12.2769 30.7052 12.1186 30.6584 11.9605 30.6584C11.7383 30.6584 11.52 30.744 11.3578 30.9107L10.5285 31.74C9.61359 32.6508 8.13022 32.6549 7.21532 31.74C6.30041 30.8251 6.30041 29.3417 7.21532 28.4268L8.04464 27.5975C8.32676 27.3154 8.37388 26.8749 8.16423 26.5373C7.34773 25.2418 6.76202 23.8354 6.42412 22.3518C6.33853 21.9627 5.99231 21.6892 5.59029 21.6892H4.42307C3.1321 21.6889 2.08023 20.6371 2.08023 19.3461C2.08023 18.0551 3.13202 17.0033 4.42307 17.0033H5.59029C5.99229 17.0033 6.33852 16.7253 6.42412 16.3365C6.762 14.8573 7.34773 13.4506 8.16423 12.151C8.37358 11.8131 8.32676 11.373 8.04464 11.0908L7.21532 10.2615C6.30041 9.35069 6.30041 7.8632 7.21532 6.95242C8.13022 6.03751 9.61359 6.03751 10.5285 6.95242L11.3578 7.78174C11.6399 8.06386 12.0804 8.11098 12.418 7.89715C13.7135 7.08065 15.1199 6.49914 16.6035 6.16155C16.9927 6.07178 17.2661 5.72556 17.2661 5.32772V4.1605C17.2661 2.86922 18.3179 1.81743 19.609 1.81743C20.9 1.81743 21.9518 2.86922 21.9518 4.16027V5.32749C21.9518 5.72501 22.2297 6.07125 22.6186 6.16132C24.0978 6.4992 25.5045 7.08042 26.8041 7.89692C27.142 8.11075 27.5821 8.06363 27.8643 7.78151L28.6895 6.95219C29.6044 6.03728 31.0923 6.03728 32.0027 6.95219C32.4473 7.39266 32.691 7.98253 32.691 8.60672C32.691 9.2309 32.4473 9.82074 32.0027 10.2612L31.1733 11.0906C30.8912 11.3727 30.8441 11.8131 31.0579 12.1508C31.8744 13.4462 32.4559 14.8571 32.7935 16.3362C32.8833 16.7254 33.2295 17.003 33.6274 17.003H34.7946C36.0856 17.003 37.1374 18.0548 37.1374 19.3459C37.1377 20.6372 36.0859 21.6889 34.7946 21.6889Z"
                  fill="#1C462C"
                />
                <path
                  d="M23.5513 16.1478C23.5513 16.618 23.9319 17.0027 24.4063 17.0027C24.8766 17.0027 25.2613 16.618 25.2613 16.1478C25.2613 13.4715 23.0852 11.2954 20.4089 11.2954C19.9386 11.2954 19.554 11.6801 19.554 12.1504C19.554 12.6248 19.9387 13.0054 20.4089 13.0054C22.1404 13.0054 23.5513 14.4163 23.5513 16.1478Z"
                  fill="#AB8F5B"
                />
                <path
                  d="M25.2055 21.689C24.7311 21.689 24.3506 22.0696 24.3506 22.544C24.3506 24.2755 22.9397 25.6821 21.2082 25.6821C20.738 25.6821 20.3533 26.0668 20.3533 26.5371C20.3533 27.0116 20.738 27.3921 21.2082 27.3921C23.8845 27.3921 26.0606 25.216 26.0606 22.5439C26.0606 22.0695 25.6758 21.689 25.2055 21.689Z"
                  fill="#AB8F5B"
                />
                <path
                  d="M15.6115 20.8884C13.88 20.8884 12.4734 19.4776 12.4734 17.7461C12.4734 17.2716 12.0887 16.8911 11.6184 16.8911C11.1439 16.8911 10.7634 17.2716 10.7634 17.7461C10.7634 20.4223 12.9395 22.5984 15.6116 22.5984C16.086 22.5984 16.4665 22.2137 16.4665 21.7435C16.4665 21.269 16.086 20.8885 15.6116 20.8885L15.6115 20.8884Z"
                  fill="#AB8F5B"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("cancer") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.disease.diabetes ? 'select' : ''
            }`"
            @click="
              form.disease.diabetes = !form.disease.diabetes;
              form.disease.none = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 28 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.3087 30.9902V39.8933C11.3087 41.1873 12.3577 42.2363 13.6516 42.2363V42.2363C14.9456 42.2363 15.9946 41.1873 15.9946 39.8933V30.9902"
                  stroke="#1C462C"
                  stroke-width="1.5"
                />
                <path
                  d="M1 6C1 3.23858 3.23858 1 6 1H21.3035C24.065 1 26.3035 3.23858 26.3035 6V18.3376C26.3035 25.325 20.6391 30.9894 13.6518 30.9894V30.9894C6.66439 30.9894 1 25.325 1 18.3376V6Z"
                  stroke="#1C462C"
                  stroke-width="1.5"
                />
                <rect
                  x="5.68567"
                  y="6.62354"
                  width="15.9319"
                  height="8.43451"
                  rx="2"
                  stroke="#AB8E5A"
                  stroke-width="1.5"
                />
                <rect
                  x="5.68567"
                  y="19.7427"
                  width="5.62301"
                  height="2.8115"
                  rx="1"
                  fill="#1C462C"
                />
                <rect
                  x="15.9948"
                  y="19.7427"
                  width="5.62301"
                  height="2.8115"
                  rx="1"
                  fill="#1C462C"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("diabete") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.disease.hypertension ? 'select' : ''
            }`"
            @click="
              form.disease.hypertension = !form.disease.hypertension;
              form.disease.none = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 46 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.4545 27.3218C25.4534 29.8905 23.7577 32.086 21.5817 33.6307C19.4058 35.1755 16.8475 36 14.2304 36C11.6133 36 9.05501 35.1755 6.87909 33.6307C4.70317 32.086 3.0074 29.8905 2.00628 27.3218C1.00516 24.7531 0.743658 21.9268 1.25486 19.2002C1.76606 16.4736 3.65152 14.2576 5.24242 12.1364L14.2304 1L21.5817 10.5455"
                  stroke="#264E35"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6061 17.1741H19.8511L22.4896 21.6817L28.0962 12.6665L33.5253 26.4544L35.9607 20.8862H44.4849"
                  stroke="#AA8E5B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3517 29.4798C12.3517 28.9766 11.9481 28.573 11.4449 28.573C9.60851 28.573 8.11663 27.0767 8.11663 25.2403C8.11663 24.7415 7.70861 24.3335 7.20984 24.3335C6.70662 24.3335 6.30304 24.7415 6.30304 25.2403C6.30304 28.0787 8.61103 30.3867 11.445 30.3867C11.9482 30.3867 12.3518 29.9787 12.3518 29.4799L12.3517 29.4798Z"
                  fill="#264E35"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("hypertension") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.disease.cardiovascular ? 'select' : ''
            }`"
            @click="
              form.disease.cardiovascular = !form.disease.cardiovascular;
              form.disease.none = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 45 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 16.8H14.988L19.1325 9L25.3494 22L30.012 12.64L32.0843 16.8H44"
                  stroke="#AA8E5A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M38.7234 19.4957C38.7436 19.4957 38.7618 19.5078 38.7696 19.5265C38.7774 19.5451 38.7732 19.5666 38.7589 19.5809L23.6867 34.7637C23.3076 35.1454 22.6929 35.1454 22.3139 34.7637L7.24162 19.5809C7.2274 19.5666 7.22319 19.5451 7.23095 19.5265C7.23871 19.5078 7.25692 19.4957 7.27711 19.4957H9.88068C9.894 19.4957 9.90678 19.501 9.91616 19.5105L23.0031 32.6933L36.0851 19.5105C36.0945 19.501 36.1072 19.4957 36.1206 19.4957H38.7234ZM4.22448 14.0321C4.20076 14.0321 4.18031 14.0154 4.17551 13.9922C3.4634 10.5388 4.43785 6.80255 7.0989 4.12196C11.2974 -0.10732 18.1049 -0.10732 22.3033 4.12196C22.594 4.41482 22.7783 4.62604 22.8902 4.76456C22.9432 4.83012 22.9799 4.87942 23.0041 4.91341L23.0378 4.87251C23.0853 4.81509 23.1514 4.73567 23.2261 4.64764C23.3751 4.47197 23.5592 4.26069 23.6967 4.12199L23.6967 4.12196C27.8952 -0.10732 34.7027 -0.10732 38.9011 4.12196C41.5621 6.80245 42.5366 10.5388 41.8245 13.9922C41.8197 14.0154 41.7993 14.0321 41.7755 14.0321H39.8866C39.8712 14.0321 39.8567 14.025 39.8472 14.0128C39.8377 14.0006 39.8344 13.9848 39.8381 13.9699C40.5765 11.037 39.8063 7.79836 37.5284 5.50384C34.0879 2.03812 28.5099 2.03812 25.0697 5.50384C24.5919 5.9855 24.1751 6.51387 23.823 7.08034C23.4428 7.6928 22.5575 7.69279 22.1774 7.08032C21.8257 6.51382 21.4089 5.9855 20.9307 5.50384C17.4902 2.03812 11.9122 2.03812 8.47203 5.50384C6.1941 7.79846 5.42397 11.0371 6.16225 13.9699C6.16601 13.9848 6.16267 14.0006 6.1532 14.0128C6.14372 14.025 6.12917 14.0321 6.11376 14.0321H4.22448Z"
                  fill="#264E35"
                  stroke="#264E35"
                  stroke-width="0.1"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("cvd") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${form.disease.kidney ? 'select' : ''}`"
            @click="
              form.disease.kidney = !form.disease.kidney;
              form.disease.none = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="26"
                height="28"
                viewBox="0 0 26 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12811_16234)">
                  <path
                    d="M19.0988 0H19.0454C17.8408 0 16.9962 0.306229 16.465 0.912031C15.6004 1.9106 15.7982 3.35299 16.0716 5.20146C16.1649 5.86717 16.2761 6.67047 16.3294 7.50927C15.9941 7.38317 15.709 7.15145 15.5173 6.84916C15.3256 6.54687 15.2377 6.19047 15.267 5.83389V2.7716C15.267 2.57738 15.1897 2.39112 15.0522 2.25379C14.9146 2.11646 14.7281 2.03931 14.5335 2.03931C14.339 2.03931 14.1525 2.11646 14.0149 2.25379C13.8774 2.39112 13.8001 2.57738 13.8001 2.7716V5.82057C13.7684 6.36365 13.8828 6.90531 14.1313 7.38944C14.3287 7.77658 14.6077 8.11648 14.9492 8.3858C14.5674 8.68857 14.2638 9.07828 14.0639 9.52227C13.864 9.96627 13.7735 10.4516 13.8001 10.9377V27.2677C13.8001 27.4619 13.8774 27.6482 14.0149 27.7855C14.1525 27.9228 14.339 28 14.5335 28C14.7281 28 14.9146 27.9228 15.0522 27.7855C15.1897 27.6482 15.267 27.4619 15.267 27.2677V10.92C15.2386 10.564 15.3284 10.2086 15.5224 9.90864C15.7164 9.60867 16.0039 9.38077 16.3405 9.2601C16.2872 10.0989 16.1738 10.9066 16.0827 11.5701C15.8182 13.4097 15.6115 14.861 16.4805 15.864C17.0451 16.4831 17.8808 16.7738 19.1077 16.7738C23.2306 16.7738 25.9977 13.4031 25.9977 8.3858C25.9977 3.36852 23.2261 0 19.0988 0ZM17.5052 11.883L17.5229 11.7543C17.7032 10.6386 17.8035 9.51138 17.823 8.38136C17.8028 7.24752 17.701 6.11659 17.5185 4.99731C17.3251 3.64368 17.1429 2.36329 17.5674 1.87288C17.8163 1.58884 18.3431 1.42907 19.0921 1.42907C23.1083 1.45348 24.533 5.18814 24.533 8.37692C24.533 10.181 24.0885 11.8475 23.3062 13.0658C22.3438 14.557 20.928 15.3004 19.0988 15.3004C18.3097 15.3004 17.8119 15.1606 17.5718 14.8566C17.1451 14.3994 17.3207 13.1767 17.5052 11.883Z"
                    fill="#135033"
                  />
                  <path
                    d="M11.869 7.38944C12.1158 6.91029 12.2301 6.37408 12.2001 5.83611V2.77381C12.2007 2.67738 12.1822 2.58179 12.1455 2.49255C12.1089 2.40332 12.0549 2.32221 11.9868 2.25392C11.9186 2.18563 11.8375 2.1315 11.7482 2.09466C11.659 2.05783 11.5633 2.03901 11.4667 2.03931C11.2723 2.03989 11.0861 2.11723 10.9487 2.25444C10.8113 2.39164 10.7338 2.57756 10.7332 2.7716V5.85164C10.76 6.20791 10.6694 6.56317 10.4752 6.86324C10.281 7.16332 9.99383 7.39175 9.65747 7.51371C9.71082 6.67491 9.82417 5.86495 9.91752 5.20368C10.1798 3.36408 10.3887 1.9106 9.5219 0.914249C8.99514 0.297353 8.13722 0 6.90145 0C2.77185 0 -0.00195312 3.36852 -0.00195312 8.3858C-0.00195312 13.4031 2.77185 16.7738 6.90145 16.7738C8.13277 16.7738 8.99514 16.4742 9.53301 15.8596C10.3976 14.8632 10.1998 13.4186 9.92641 11.5701C9.83528 10.9044 9.72193 10.1033 9.66859 9.26232C10.0039 9.38842 10.289 9.62015 10.4807 9.92244C10.6724 10.2247 10.7603 10.5811 10.731 10.9377V27.2677C10.731 27.4619 10.8083 27.6482 10.9458 27.7855C11.0834 27.9228 11.2699 28 11.4645 28C11.659 28 11.8455 27.9228 11.9831 27.7855C12.1206 27.6482 12.1979 27.4619 12.1979 27.2677V10.951C12.2262 10.463 12.1368 9.97538 11.9372 9.52903C11.7377 9.08267 11.4338 8.69062 11.051 8.3858C11.392 8.11598 11.6709 7.7762 11.869 7.38944ZM8.49505 4.88857L8.47727 5.0195C8.29802 6.13464 8.19775 7.26101 8.17722 8.39024C8.19833 9.52403 8.30008 10.6549 8.48172 11.7743C8.65953 13.0258 8.82845 14.2152 8.51284 14.7767L8.42615 14.8743C8.17945 15.1583 7.65047 15.3181 6.90367 15.3181C2.88965 15.3181 1.46719 11.5879 1.46719 8.39467C1.46719 5.20146 2.88965 1.47345 6.90367 1.47345C7.69047 1.47345 8.18833 1.61325 8.42838 1.91726C8.85511 2.37217 8.68175 3.59486 8.49505 4.88857Z"
                    fill="#135033"
                  />
                  <path
                    d="M5.58738 13.9689C5.49317 13.9683 5.40065 13.9439 5.31845 13.8979C2.93582 12.5088 2.93359 10.2209 2.93359 10.1255C2.93592 9.9797 2.99542 9.84064 3.09931 9.73816C3.2032 9.63567 3.3432 9.57796 3.48924 9.57739C3.63623 9.57915 3.77652 9.63898 3.87942 9.74379C3.98231 9.8486 4.03941 9.98984 4.03823 10.1366C4.03823 10.2143 4.06712 11.8919 5.87187 12.9415C5.97453 13.0044 6.05391 13.099 6.09804 13.2109C6.14218 13.3228 6.14869 13.4461 6.11659 13.562C6.08449 13.6779 6.01551 13.7803 5.92006 13.8537C5.82461 13.9271 5.70785 13.9675 5.58738 13.9689Z"
                    fill="#AF8D50"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12811_16234">
                    <rect width="26" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="label">
              {{ $t("kidney") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${form.disease.none ? 'select' : ''}`"
            @click="
              form.disease.none = !form.disease.none;
              form.disease.cancer = false;
              form.disease.diabetes = false;
              form.disease.hypertension = false;
              form.disease.cardiovascular = false;
              form.disease.kidney = false;
              form.disease.other = false;
              otherClickNext = false;
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="30"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24Z"
                  stroke="#1C462C"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.90002 12.5H17.1"
                  stroke="#AB8E5A"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("none") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${form.disease.other ? 'select' : ''}`"
            @click="
              form.disease.other = !form.disease.other;
              form.disease.none = false;
              form.disease.other
                ? (form.disease.otherClickNext = true)
                : (form.disease.otherClickNext = false);
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.961485 11.4562C0.957251 13.0798 1.33659 14.6814 2.0686 16.1307C2.93655 17.8673 4.27085 19.328 5.92206 20.3491C7.57327 21.3703 9.47617 21.9115 11.4176 21.9123C13.0412 21.9165 14.6429 21.5372 16.0921 20.8052L23.1039 23.1424L20.7666 16.1307C21.4986 14.6814 21.878 13.0798 21.8737 11.4562C21.873 9.51472 21.3317 7.61182 20.3106 5.96061C19.2895 4.3094 17.8288 2.9751 16.0921 2.10716C14.6429 1.37514 13.0412 0.995802 11.4176 1.00004H10.8026C8.23852 1.14149 5.81677 2.22372 4.00097 4.03952C2.18517 5.85532 1.10294 8.27708 0.961485 10.8411V11.4562Z"
                  stroke="#264E35"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.181 8.66455V13.7743"
                  stroke="#AA8E5A"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7359 11.2197H8.6261"
                  stroke="#AA8E5A"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("other") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            v-if="form.disease.other"
            :class="`disease-long-card select ${otherClickNext ? 'error' : ''}`"
          >
            <div class="none-41 m-10 ml-0">
              <el-input
                v-model="form.disease.otherData"
                :placeholder="$t('pleaseFillDisease')"
              />
            </div>
          </div>
        </div>
        <div
          class="fs-14 fw-500 fc-2D7617 mt-6"
          style="max-width: 600px; margin: auto"
        >
          {{ $t("suggestedisease") }}
        </div>
        <div
          v-if="otherClickNext"
          class="mx-auto"
          style="margin-left: 0; font-size: 12px; color: red"
        >
          {{ $t("pleaseFillDiseaseCompletely") }}
        </div>
        <!-- <div class="body mt-36">
          <div
            :class="`disease-card flex-mid ${
              form.disease.cancer ? 'select' : ''
            }`"
            @click="form.disease.cancer = !form.disease.cancer"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="39"
                  height="39"
                  viewBox="0 0 39 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.7946 15.293H34.2945C33.961 14.0831 33.478 12.9246 32.858 11.8301L33.2128 11.4711C33.978 10.7059 34.4012 9.68831 34.4012 8.60667C34.4012 7.52503 33.978 6.50752 33.2128 5.74224C31.6353 4.16467 29.0616 4.16047 27.4841 5.74224L27.125 6.09712C26.0306 5.47713 24.8678 4.99403 23.6621 4.66063V4.16052C23.6621 1.92448 21.8451 0.107422 19.609 0.107422C17.3775 0.107422 15.5559 1.92448 15.5559 4.16052V4.66063C14.3502 4.99404 13.1875 5.47713 12.0931 6.09712L11.7382 5.74224C10.1564 4.16047 7.58698 4.16047 6.0049 5.74224C4.42733 7.31982 4.42733 9.89345 6.0049 11.471L6.36395 11.8301C5.73978 12.9245 5.25666 14.0873 4.92327 15.293H4.42315C2.18742 15.293 0.370361 17.11 0.370361 19.3461C0.370361 21.5776 2.18742 23.3991 4.42346 23.3991H4.92357C5.25698 24.6048 5.74007 25.7676 6.36426 26.862L6.00521 27.2169C4.42764 28.7987 4.42764 31.3681 6.00521 32.9502C7.58698 34.5278 10.1564 34.5278 11.7385 32.9502L12.0934 32.5911C13.1878 33.2153 14.3505 33.6984 15.5562 34.0318V34.5319C15.5562 36.768 17.3774 38.585 19.6093 38.585C21.8454 38.585 23.6624 36.768 23.6624 34.5319V34.0318C24.8681 33.6984 26.0309 33.2153 27.1253 32.5911L27.4844 32.9502C29.0619 34.5278 31.6356 34.5278 33.2132 32.9502C34.7949 31.3684 34.7949 28.799 33.2132 27.2169L32.8583 26.862C33.4783 25.7676 33.9614 24.6048 34.2948 23.3991H34.7949C37.0309 23.3991 38.848 21.578 38.848 19.3461C38.8477 17.11 37.0306 15.293 34.7946 15.293ZM34.7946 21.6889H33.6273C33.2298 21.6889 32.8836 21.9627 32.7935 22.3515C32.4556 23.8352 31.8744 25.2415 31.0579 26.537C30.8441 26.8749 30.8912 27.315 31.1733 27.5972L32.0027 28.4265C32.9176 29.3414 32.9176 30.8248 32.0027 31.7397C31.0919 32.6505 29.6044 32.6505 28.6936 31.7397L27.8643 30.9104C27.5822 30.6283 27.1417 30.577 26.8041 30.7908C25.5045 31.6073 24.0978 32.193 22.6186 32.5309C22.2294 32.6165 21.9518 32.9627 21.9518 33.3647V34.5319C21.9518 35.8229 20.9 36.8748 19.6089 36.8748C18.3179 36.8748 17.2661 35.823 17.2661 34.5319V33.3647C17.2661 32.9627 16.9923 32.6165 16.6035 32.5309C15.1198 32.193 13.7135 31.6073 12.418 30.7908C12.2769 30.7052 12.1186 30.6584 11.9605 30.6584C11.7383 30.6584 11.52 30.744 11.3578 30.9107L10.5285 31.74C9.61359 32.6508 8.13022 32.6549 7.21532 31.74C6.30041 30.8251 6.30041 29.3417 7.21532 28.4268L8.04464 27.5975C8.32676 27.3154 8.37388 26.8749 8.16423 26.5373C7.34773 25.2418 6.76202 23.8354 6.42412 22.3518C6.33853 21.9627 5.99231 21.6892 5.59029 21.6892H4.42307C3.1321 21.6889 2.08023 20.6371 2.08023 19.3461C2.08023 18.0551 3.13202 17.0033 4.42307 17.0033H5.59029C5.99229 17.0033 6.33852 16.7253 6.42412 16.3365C6.762 14.8573 7.34773 13.4506 8.16423 12.151C8.37358 11.8131 8.32676 11.373 8.04464 11.0908L7.21532 10.2615C6.30041 9.35069 6.30041 7.8632 7.21532 6.95242C8.13022 6.03751 9.61359 6.03751 10.5285 6.95242L11.3578 7.78174C11.6399 8.06386 12.0804 8.11098 12.418 7.89715C13.7135 7.08065 15.1199 6.49914 16.6035 6.16155C16.9927 6.07178 17.2661 5.72556 17.2661 5.32772V4.1605C17.2661 2.86922 18.3179 1.81743 19.609 1.81743C20.9 1.81743 21.9518 2.86922 21.9518 4.16027V5.32749C21.9518 5.72501 22.2297 6.07125 22.6186 6.16132C24.0978 6.4992 25.5045 7.08042 26.8041 7.89692C27.142 8.11075 27.5821 8.06363 27.8643 7.78151L28.6895 6.95219C29.6044 6.03728 31.0923 6.03728 32.0027 6.95219C32.4473 7.39266 32.691 7.98253 32.691 8.60672C32.691 9.2309 32.4473 9.82074 32.0027 10.2612L31.1733 11.0906C30.8912 11.3727 30.8441 11.8131 31.0579 12.1508C31.8744 13.4462 32.4559 14.8571 32.7935 16.3362C32.8833 16.7254 33.2295 17.003 33.6274 17.003H34.7946C36.0856 17.003 37.1374 18.0548 37.1374 19.3459C37.1377 20.6372 36.0859 21.6889 34.7946 21.6889Z"
                    fill="#1C462C"
                  />
                  <path
                    d="M23.5513 16.1478C23.5513 16.618 23.9319 17.0027 24.4063 17.0027C24.8766 17.0027 25.2613 16.618 25.2613 16.1478C25.2613 13.4715 23.0852 11.2954 20.4089 11.2954C19.9386 11.2954 19.554 11.6801 19.554 12.1504C19.554 12.6248 19.9387 13.0054 20.4089 13.0054C22.1404 13.0054 23.5513 14.4163 23.5513 16.1478Z"
                    fill="#AB8F5B"
                  />
                  <path
                    d="M25.2055 21.689C24.7311 21.689 24.3506 22.0696 24.3506 22.544C24.3506 24.2755 22.9397 25.6821 21.2082 25.6821C20.738 25.6821 20.3533 26.0668 20.3533 26.5371C20.3533 27.0116 20.738 27.3921 21.2082 27.3921C23.8845 27.3921 26.0606 25.216 26.0606 22.5439C26.0606 22.0695 25.6758 21.689 25.2055 21.689Z"
                    fill="#AB8F5B"
                  />
                  <path
                    d="M15.6115 20.8884C13.88 20.8884 12.4734 19.4776 12.4734 17.7461C12.4734 17.2716 12.0887 16.8911 11.6184 16.8911C11.1439 16.8911 10.7634 17.2716 10.7634 17.7461C10.7634 20.4223 12.9395 22.5984 15.6116 22.5984C16.086 22.5984 16.4665 22.2137 16.4665 21.7435C16.4665 21.269 16.086 20.8885 15.6116 20.8885L15.6115 20.8884Z"
                    fill="#AB8F5B"
                  />
                </svg>
              </div>
              <div class="label">{{ $t('cancer') }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-card flex-mid ${
              form.disease.diabetes ? 'select' : ''
            }`"
            @click="form.disease.diabetes = !form.disease.diabetes"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="28"
                  height="43"
                  viewBox="0 0 28 43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3087 30.9902V39.8933C11.3087 41.1873 12.3577 42.2363 13.6516 42.2363V42.2363C14.9456 42.2363 15.9946 41.1873 15.9946 39.8933V30.9902"
                    stroke="#1C462C"
                    stroke-width="1.5"
                  />
                  <path
                    d="M1 6C1 3.23858 3.23858 1 6 1H21.3035C24.065 1 26.3035 3.23858 26.3035 6V18.3376C26.3035 25.325 20.6391 30.9894 13.6518 30.9894V30.9894C6.66439 30.9894 1 25.325 1 18.3376V6Z"
                    stroke="#1C462C"
                    stroke-width="1.5"
                  />
                  <rect
                    x="5.68567"
                    y="6.62354"
                    width="15.9319"
                    height="8.43451"
                    rx="2"
                    stroke="#AB8E5A"
                    stroke-width="1.5"
                  />
                  <rect
                    x="5.68567"
                    y="19.7427"
                    width="5.62301"
                    height="2.8115"
                    rx="1"
                    fill="#1C462C"
                  />
                  <rect
                    x="15.9948"
                    y="19.7427"
                    width="5.62301"
                    height="2.8115"
                    rx="1"
                    fill="#1C462C"
                  />
                </svg>
              </div>
              <div class="label">{{ $t('diabete') }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-card flex-mid ${
              form.disease.hypertension ? 'select' : ''
            }`"
            @click="form.disease.hypertension = !form.disease.hypertension"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="46"
                  height="37"
                  viewBox="0 0 46 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.4545 27.3218C25.4534 29.8905 23.7577 32.086 21.5817 33.6307C19.4058 35.1755 16.8475 36 14.2304 36C11.6133 36 9.05501 35.1755 6.87909 33.6307C4.70317 32.086 3.0074 29.8905 2.00628 27.3218C1.00516 24.7531 0.743658 21.9268 1.25486 19.2002C1.76606 16.4736 3.65152 14.2576 5.24242 12.1364L14.2304 1L21.5817 10.5455"
                    stroke="#264E35"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.6061 17.1741H19.8511L22.4896 21.6817L28.0962 12.6665L33.5253 26.4544L35.9607 20.8862H44.4849"
                    stroke="#AA8E5B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.3517 29.4798C12.3517 28.9766 11.9481 28.573 11.4449 28.573C9.60851 28.573 8.11663 27.0767 8.11663 25.2403C8.11663 24.7415 7.70861 24.3335 7.20984 24.3335C6.70662 24.3335 6.30304 24.7415 6.30304 25.2403C6.30304 28.0787 8.61103 30.3867 11.445 30.3867C11.9482 30.3867 12.3518 29.9787 12.3518 29.4799L12.3517 29.4798Z"
                    fill="#264E35"
                  />
                </svg>
              </div>
              <div class="label">{{ $t('hypertension') }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-card flex-mid ${
              form.disease.cardiovascular ? 'select' : ''
            }`"
            @click="form.disease.cardiovascular = !form.disease.cardiovascular"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="45"
                  height="36"
                  viewBox="0 0 45 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 16.8H14.988L19.1325 9L25.3494 22L30.012 12.64L32.0843 16.8H44"
                    stroke="#AA8E5A"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M38.7234 19.4957C38.7436 19.4957 38.7618 19.5078 38.7696 19.5265C38.7774 19.5451 38.7732 19.5666 38.7589 19.5809L23.6867 34.7637C23.3076 35.1454 22.6929 35.1454 22.3139 34.7637L7.24162 19.5809C7.2274 19.5666 7.22319 19.5451 7.23095 19.5265C7.23871 19.5078 7.25692 19.4957 7.27711 19.4957H9.88068C9.894 19.4957 9.90678 19.501 9.91616 19.5105L23.0031 32.6933L36.0851 19.5105C36.0945 19.501 36.1072 19.4957 36.1206 19.4957H38.7234ZM4.22448 14.0321C4.20076 14.0321 4.18031 14.0154 4.17551 13.9922C3.4634 10.5388 4.43785 6.80255 7.0989 4.12196C11.2974 -0.10732 18.1049 -0.10732 22.3033 4.12196C22.594 4.41482 22.7783 4.62604 22.8902 4.76456C22.9432 4.83012 22.9799 4.87942 23.0041 4.91341L23.0378 4.87251C23.0853 4.81509 23.1514 4.73567 23.2261 4.64764C23.3751 4.47197 23.5592 4.26069 23.6967 4.12199L23.6967 4.12196C27.8952 -0.10732 34.7027 -0.10732 38.9011 4.12196C41.5621 6.80245 42.5366 10.5388 41.8245 13.9922C41.8197 14.0154 41.7993 14.0321 41.7755 14.0321H39.8866C39.8712 14.0321 39.8567 14.025 39.8472 14.0128C39.8377 14.0006 39.8344 13.9848 39.8381 13.9699C40.5765 11.037 39.8063 7.79836 37.5284 5.50384C34.0879 2.03812 28.5099 2.03812 25.0697 5.50384C24.5919 5.9855 24.1751 6.51387 23.823 7.08034C23.4428 7.6928 22.5575 7.69279 22.1774 7.08032C21.8257 6.51382 21.4089 5.9855 20.9307 5.50384C17.4902 2.03812 11.9122 2.03812 8.47203 5.50384C6.1941 7.79846 5.42397 11.0371 6.16225 13.9699C6.16601 13.9848 6.16267 14.0006 6.1532 14.0128C6.14372 14.025 6.12917 14.0321 6.11376 14.0321H4.22448Z"
                    fill="#264E35"
                    stroke="#264E35"
                    stroke-width="0.1"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="label">{{ $t('cvd') }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextDisease"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_disease_family'"
      class="center disease-container"
    >
      <!-- class="center disease-family-container" -->
      <div class="form-container">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("famdisease") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6">
          {{ $t("morethanonedisease2") }}
        </div>

        <div class="body mt-4 pt-34">
          <div
            :class="`disease-long-card ${
              form.diseaseFamily.cancer ? 'select' : ''
            }`"
            @click="form.diseaseFamily.cancer = !form.diseaseFamily.cancer"
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.7946 15.293H34.2945C33.961 14.0831 33.478 12.9246 32.858 11.8301L33.2128 11.4711C33.978 10.7059 34.4012 9.68831 34.4012 8.60667C34.4012 7.52503 33.978 6.50752 33.2128 5.74224C31.6353 4.16467 29.0616 4.16047 27.4841 5.74224L27.125 6.09712C26.0306 5.47713 24.8678 4.99403 23.6621 4.66063V4.16052C23.6621 1.92448 21.8451 0.107422 19.609 0.107422C17.3775 0.107422 15.5559 1.92448 15.5559 4.16052V4.66063C14.3502 4.99404 13.1875 5.47713 12.0931 6.09712L11.7382 5.74224C10.1564 4.16047 7.58698 4.16047 6.0049 5.74224C4.42733 7.31982 4.42733 9.89345 6.0049 11.471L6.36395 11.8301C5.73978 12.9245 5.25666 14.0873 4.92327 15.293H4.42315C2.18742 15.293 0.370361 17.11 0.370361 19.3461C0.370361 21.5776 2.18742 23.3991 4.42346 23.3991H4.92357C5.25698 24.6048 5.74007 25.7676 6.36426 26.862L6.00521 27.2169C4.42764 28.7987 4.42764 31.3681 6.00521 32.9502C7.58698 34.5278 10.1564 34.5278 11.7385 32.9502L12.0934 32.5911C13.1878 33.2153 14.3505 33.6984 15.5562 34.0318V34.5319C15.5562 36.768 17.3774 38.585 19.6093 38.585C21.8454 38.585 23.6624 36.768 23.6624 34.5319V34.0318C24.8681 33.6984 26.0309 33.2153 27.1253 32.5911L27.4844 32.9502C29.0619 34.5278 31.6356 34.5278 33.2132 32.9502C34.7949 31.3684 34.7949 28.799 33.2132 27.2169L32.8583 26.862C33.4783 25.7676 33.9614 24.6048 34.2948 23.3991H34.7949C37.0309 23.3991 38.848 21.578 38.848 19.3461C38.8477 17.11 37.0306 15.293 34.7946 15.293ZM34.7946 21.6889H33.6273C33.2298 21.6889 32.8836 21.9627 32.7935 22.3515C32.4556 23.8352 31.8744 25.2415 31.0579 26.537C30.8441 26.8749 30.8912 27.315 31.1733 27.5972L32.0027 28.4265C32.9176 29.3414 32.9176 30.8248 32.0027 31.7397C31.0919 32.6505 29.6044 32.6505 28.6936 31.7397L27.8643 30.9104C27.5822 30.6283 27.1417 30.577 26.8041 30.7908C25.5045 31.6073 24.0978 32.193 22.6186 32.5309C22.2294 32.6165 21.9518 32.9627 21.9518 33.3647V34.5319C21.9518 35.8229 20.9 36.8748 19.6089 36.8748C18.3179 36.8748 17.2661 35.823 17.2661 34.5319V33.3647C17.2661 32.9627 16.9923 32.6165 16.6035 32.5309C15.1198 32.193 13.7135 31.6073 12.418 30.7908C12.2769 30.7052 12.1186 30.6584 11.9605 30.6584C11.7383 30.6584 11.52 30.744 11.3578 30.9107L10.5285 31.74C9.61359 32.6508 8.13022 32.6549 7.21532 31.74C6.30041 30.8251 6.30041 29.3417 7.21532 28.4268L8.04464 27.5975C8.32676 27.3154 8.37388 26.8749 8.16423 26.5373C7.34773 25.2418 6.76202 23.8354 6.42412 22.3518C6.33853 21.9627 5.99231 21.6892 5.59029 21.6892H4.42307C3.1321 21.6889 2.08023 20.6371 2.08023 19.3461C2.08023 18.0551 3.13202 17.0033 4.42307 17.0033H5.59029C5.99229 17.0033 6.33852 16.7253 6.42412 16.3365C6.762 14.8573 7.34773 13.4506 8.16423 12.151C8.37358 11.8131 8.32676 11.373 8.04464 11.0908L7.21532 10.2615C6.30041 9.35069 6.30041 7.8632 7.21532 6.95242C8.13022 6.03751 9.61359 6.03751 10.5285 6.95242L11.3578 7.78174C11.6399 8.06386 12.0804 8.11098 12.418 7.89715C13.7135 7.08065 15.1199 6.49914 16.6035 6.16155C16.9927 6.07178 17.2661 5.72556 17.2661 5.32772V4.1605C17.2661 2.86922 18.3179 1.81743 19.609 1.81743C20.9 1.81743 21.9518 2.86922 21.9518 4.16027V5.32749C21.9518 5.72501 22.2297 6.07125 22.6186 6.16132C24.0978 6.4992 25.5045 7.08042 26.8041 7.89692C27.142 8.11075 27.5821 8.06363 27.8643 7.78151L28.6895 6.95219C29.6044 6.03728 31.0923 6.03728 32.0027 6.95219C32.4473 7.39266 32.691 7.98253 32.691 8.60672C32.691 9.2309 32.4473 9.82074 32.0027 10.2612L31.1733 11.0906C30.8912 11.3727 30.8441 11.8131 31.0579 12.1508C31.8744 13.4462 32.4559 14.8571 32.7935 16.3362C32.8833 16.7254 33.2295 17.003 33.6274 17.003H34.7946C36.0856 17.003 37.1374 18.0548 37.1374 19.3459C37.1377 20.6372 36.0859 21.6889 34.7946 21.6889Z"
                  fill="#1C462C"
                />
                <path
                  d="M23.5513 16.1478C23.5513 16.618 23.9319 17.0027 24.4063 17.0027C24.8766 17.0027 25.2613 16.618 25.2613 16.1478C25.2613 13.4715 23.0852 11.2954 20.4089 11.2954C19.9386 11.2954 19.554 11.6801 19.554 12.1504C19.554 12.6248 19.9387 13.0054 20.4089 13.0054C22.1404 13.0054 23.5513 14.4163 23.5513 16.1478Z"
                  fill="#AB8F5B"
                />
                <path
                  d="M25.2055 21.689C24.7311 21.689 24.3506 22.0696 24.3506 22.544C24.3506 24.2755 22.9397 25.6821 21.2082 25.6821C20.738 25.6821 20.3533 26.0668 20.3533 26.5371C20.3533 27.0116 20.738 27.3921 21.2082 27.3921C23.8845 27.3921 26.0606 25.216 26.0606 22.5439C26.0606 22.0695 25.6758 21.689 25.2055 21.689Z"
                  fill="#AB8F5B"
                />
                <path
                  d="M15.6115 20.8884C13.88 20.8884 12.4734 19.4776 12.4734 17.7461C12.4734 17.2716 12.0887 16.8911 11.6184 16.8911C11.1439 16.8911 10.7634 17.2716 10.7634 17.7461C10.7634 20.4223 12.9395 22.5984 15.6116 22.5984C16.086 22.5984 16.4665 22.2137 16.4665 21.7435C16.4665 21.269 16.086 20.8885 15.6116 20.8885L15.6115 20.8884Z"
                  fill="#AB8F5B"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("cancer") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.diseaseFamily.diabetes ? 'select' : ''
            }`"
            @click="form.diseaseFamily.diabetes = !form.diseaseFamily.diabetes"
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 28 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.3087 30.9902V39.8933C11.3087 41.1873 12.3577 42.2363 13.6516 42.2363V42.2363C14.9456 42.2363 15.9946 41.1873 15.9946 39.8933V30.9902"
                  stroke="#1C462C"
                  stroke-width="1.5"
                />
                <path
                  d="M1 6C1 3.23858 3.23858 1 6 1H21.3035C24.065 1 26.3035 3.23858 26.3035 6V18.3376C26.3035 25.325 20.6391 30.9894 13.6518 30.9894V30.9894C6.66439 30.9894 1 25.325 1 18.3376V6Z"
                  stroke="#1C462C"
                  stroke-width="1.5"
                />
                <rect
                  x="5.68567"
                  y="6.62354"
                  width="15.9319"
                  height="8.43451"
                  rx="2"
                  stroke="#AB8E5A"
                  stroke-width="1.5"
                />
                <rect
                  x="5.68567"
                  y="19.7427"
                  width="5.62301"
                  height="2.8115"
                  rx="1"
                  fill="#1C462C"
                />
                <rect
                  x="15.9948"
                  y="19.7427"
                  width="5.62301"
                  height="2.8115"
                  rx="1"
                  fill="#1C462C"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("diabete") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.diseaseFamily.hypertension ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.hypertension = !form.diseaseFamily.hypertension
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 46 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.4545 27.3218C25.4534 29.8905 23.7577 32.086 21.5817 33.6307C19.4058 35.1755 16.8475 36 14.2304 36C11.6133 36 9.05501 35.1755 6.87909 33.6307C4.70317 32.086 3.0074 29.8905 2.00628 27.3218C1.00516 24.7531 0.743658 21.9268 1.25486 19.2002C1.76606 16.4736 3.65152 14.2576 5.24242 12.1364L14.2304 1L21.5817 10.5455"
                  stroke="#264E35"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6061 17.1741H19.8511L22.4896 21.6817L28.0962 12.6665L33.5253 26.4544L35.9607 20.8862H44.4849"
                  stroke="#AA8E5B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3517 29.4798C12.3517 28.9766 11.9481 28.573 11.4449 28.573C9.60851 28.573 8.11663 27.0767 8.11663 25.2403C8.11663 24.7415 7.70861 24.3335 7.20984 24.3335C6.70662 24.3335 6.30304 24.7415 6.30304 25.2403C6.30304 28.0787 8.61103 30.3867 11.445 30.3867C11.9482 30.3867 12.3518 29.9787 12.3518 29.4799L12.3517 29.4798Z"
                  fill="#264E35"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("hypertension") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.diseaseFamily.cardiovascular ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.cardiovascular =
                !form.diseaseFamily.cardiovascular
            "
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 45 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 16.8H14.988L19.1325 9L25.3494 22L30.012 12.64L32.0843 16.8H44"
                  stroke="#AA8E5A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M38.7234 19.4957C38.7436 19.4957 38.7618 19.5078 38.7696 19.5265C38.7774 19.5451 38.7732 19.5666 38.7589 19.5809L23.6867 34.7637C23.3076 35.1454 22.6929 35.1454 22.3139 34.7637L7.24162 19.5809C7.2274 19.5666 7.22319 19.5451 7.23095 19.5265C7.23871 19.5078 7.25692 19.4957 7.27711 19.4957H9.88068C9.894 19.4957 9.90678 19.501 9.91616 19.5105L23.0031 32.6933L36.0851 19.5105C36.0945 19.501 36.1072 19.4957 36.1206 19.4957H38.7234ZM4.22448 14.0321C4.20076 14.0321 4.18031 14.0154 4.17551 13.9922C3.4634 10.5388 4.43785 6.80255 7.0989 4.12196C11.2974 -0.10732 18.1049 -0.10732 22.3033 4.12196C22.594 4.41482 22.7783 4.62604 22.8902 4.76456C22.9432 4.83012 22.9799 4.87942 23.0041 4.91341L23.0378 4.87251C23.0853 4.81509 23.1514 4.73567 23.2261 4.64764C23.3751 4.47197 23.5592 4.26069 23.6967 4.12199L23.6967 4.12196C27.8952 -0.10732 34.7027 -0.10732 38.9011 4.12196C41.5621 6.80245 42.5366 10.5388 41.8245 13.9922C41.8197 14.0154 41.7993 14.0321 41.7755 14.0321H39.8866C39.8712 14.0321 39.8567 14.025 39.8472 14.0128C39.8377 14.0006 39.8344 13.9848 39.8381 13.9699C40.5765 11.037 39.8063 7.79836 37.5284 5.50384C34.0879 2.03812 28.5099 2.03812 25.0697 5.50384C24.5919 5.9855 24.1751 6.51387 23.823 7.08034C23.4428 7.6928 22.5575 7.69279 22.1774 7.08032C21.8257 6.51382 21.4089 5.9855 20.9307 5.50384C17.4902 2.03812 11.9122 2.03812 8.47203 5.50384C6.1941 7.79846 5.42397 11.0371 6.16225 13.9699C6.16601 13.9848 6.16267 14.0006 6.1532 14.0128C6.14372 14.025 6.12917 14.0321 6.11376 14.0321H4.22448Z"
                  fill="#264E35"
                  stroke="#264E35"
                  stroke-width="0.1"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("cvd") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`disease-long-card ${
              form.diseaseFamily.kidney ? 'select' : ''
            }`"
            @click="form.diseaseFamily.kidney = !form.diseaseFamily.kidney"
          >
            <div class="icon">
              <svg
                width="30"
                height="36"
                viewBox="0 0 45 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 16.8H14.988L19.1325 9L25.3494 22L30.012 12.64L32.0843 16.8H44"
                  stroke="#AA8E5A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M38.7234 19.4957C38.7436 19.4957 38.7618 19.5078 38.7696 19.5265C38.7774 19.5451 38.7732 19.5666 38.7589 19.5809L23.6867 34.7637C23.3076 35.1454 22.6929 35.1454 22.3139 34.7637L7.24162 19.5809C7.2274 19.5666 7.22319 19.5451 7.23095 19.5265C7.23871 19.5078 7.25692 19.4957 7.27711 19.4957H9.88068C9.894 19.4957 9.90678 19.501 9.91616 19.5105L23.0031 32.6933L36.0851 19.5105C36.0945 19.501 36.1072 19.4957 36.1206 19.4957H38.7234ZM4.22448 14.0321C4.20076 14.0321 4.18031 14.0154 4.17551 13.9922C3.4634 10.5388 4.43785 6.80255 7.0989 4.12196C11.2974 -0.10732 18.1049 -0.10732 22.3033 4.12196C22.594 4.41482 22.7783 4.62604 22.8902 4.76456C22.9432 4.83012 22.9799 4.87942 23.0041 4.91341L23.0378 4.87251C23.0853 4.81509 23.1514 4.73567 23.2261 4.64764C23.3751 4.47197 23.5592 4.26069 23.6967 4.12199L23.6967 4.12196C27.8952 -0.10732 34.7027 -0.10732 38.9011 4.12196C41.5621 6.80245 42.5366 10.5388 41.8245 13.9922C41.8197 14.0154 41.7993 14.0321 41.7755 14.0321H39.8866C39.8712 14.0321 39.8567 14.025 39.8472 14.0128C39.8377 14.0006 39.8344 13.9848 39.8381 13.9699C40.5765 11.037 39.8063 7.79836 37.5284 5.50384C34.0879 2.03812 28.5099 2.03812 25.0697 5.50384C24.5919 5.9855 24.1751 6.51387 23.823 7.08034C23.4428 7.6928 22.5575 7.69279 22.1774 7.08032C21.8257 6.51382 21.4089 5.9855 20.9307 5.50384C17.4902 2.03812 11.9122 2.03812 8.47203 5.50384C6.1941 7.79846 5.42397 11.0371 6.16225 13.9699C6.16601 13.9848 6.16267 14.0006 6.1532 14.0128C6.14372 14.025 6.12917 14.0321 6.11376 14.0321H4.22448Z"
                  fill="#264E35"
                  stroke="#264E35"
                  stroke-width="0.1"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="label">
              {{ $t("kidney") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- <div class="slide-body">
          <swiper
            :slides-per-view="1.8"
            :space-between="10"
            :centered-slides="true"
            :modules="modules"
            :mousewheel="true"
            :breakpoints="{
              '360': {
                slidesPerView: 2.2,
                spaceBetween: 20,
              },
              '700': {
                slidesPerView: 3.6,
                spaceBetween: 30,
              },
              '900': {
                slidesPerView: 4.2,
                spaceBetween: 35,
              },
              '1140': {
                slidesPerView: 5,
                spaceBetween: 35,
              },
            }"
            style="padding-top: 1rem"
          >
            <swiper-slide>
              <div class="mock-time-card flex-mid">
                <div
                  @click="
                    form.diseaseFamily.cancer = !form.diseaseFamily.cancer
                  "
                  :class="`time-card flex-mid ${
                    form.diseaseFamily.cancer ? 'select' : ''
                  }`"
                >
                  <div class="content">
                    <div class="icon flex-mid">
                      <svg
                        width="39"
                        height="39"
                        viewBox="0 0 39 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M34.7946 15.293H34.2945C33.961 14.0831 33.478 12.9246 32.858 11.8301L33.2128 11.4711C33.978 10.7059 34.4012 9.68831 34.4012 8.60667C34.4012 7.52503 33.978 6.50752 33.2128 5.74224C31.6353 4.16467 29.0616 4.16047 27.4841 5.74224L27.125 6.09712C26.0306 5.47713 24.8678 4.99403 23.6621 4.66063V4.16052C23.6621 1.92448 21.8451 0.107422 19.609 0.107422C17.3775 0.107422 15.5559 1.92448 15.5559 4.16052V4.66063C14.3502 4.99404 13.1875 5.47713 12.0931 6.09712L11.7382 5.74224C10.1564 4.16047 7.58698 4.16047 6.0049 5.74224C4.42733 7.31982 4.42733 9.89345 6.0049 11.471L6.36395 11.8301C5.73978 12.9245 5.25666 14.0873 4.92327 15.293H4.42315C2.18742 15.293 0.370361 17.11 0.370361 19.3461C0.370361 21.5776 2.18742 23.3991 4.42346 23.3991H4.92357C5.25698 24.6048 5.74007 25.7676 6.36426 26.862L6.00521 27.2169C4.42764 28.7987 4.42764 31.3681 6.00521 32.9502C7.58698 34.5278 10.1564 34.5278 11.7385 32.9502L12.0934 32.5911C13.1878 33.2153 14.3505 33.6984 15.5562 34.0318V34.5319C15.5562 36.768 17.3774 38.585 19.6093 38.585C21.8454 38.585 23.6624 36.768 23.6624 34.5319V34.0318C24.8681 33.6984 26.0309 33.2153 27.1253 32.5911L27.4844 32.9502C29.0619 34.5278 31.6356 34.5278 33.2132 32.9502C34.7949 31.3684 34.7949 28.799 33.2132 27.2169L32.8583 26.862C33.4783 25.7676 33.9614 24.6048 34.2948 23.3991H34.7949C37.0309 23.3991 38.848 21.578 38.848 19.3461C38.8477 17.11 37.0306 15.293 34.7946 15.293ZM34.7946 21.6889H33.6273C33.2298 21.6889 32.8836 21.9627 32.7935 22.3515C32.4556 23.8352 31.8744 25.2415 31.0579 26.537C30.8441 26.8749 30.8912 27.315 31.1733 27.5972L32.0027 28.4265C32.9176 29.3414 32.9176 30.8248 32.0027 31.7397C31.0919 32.6505 29.6044 32.6505 28.6936 31.7397L27.8643 30.9104C27.5822 30.6283 27.1417 30.577 26.8041 30.7908C25.5045 31.6073 24.0978 32.193 22.6186 32.5309C22.2294 32.6165 21.9518 32.9627 21.9518 33.3647V34.5319C21.9518 35.8229 20.9 36.8748 19.6089 36.8748C18.3179 36.8748 17.2661 35.823 17.2661 34.5319V33.3647C17.2661 32.9627 16.9923 32.6165 16.6035 32.5309C15.1198 32.193 13.7135 31.6073 12.418 30.7908C12.2769 30.7052 12.1186 30.6584 11.9605 30.6584C11.7383 30.6584 11.52 30.744 11.3578 30.9107L10.5285 31.74C9.61359 32.6508 8.13022 32.6549 7.21532 31.74C6.30041 30.8251 6.30041 29.3417 7.21532 28.4268L8.04464 27.5975C8.32676 27.3154 8.37388 26.8749 8.16423 26.5373C7.34773 25.2418 6.76202 23.8354 6.42412 22.3518C6.33853 21.9627 5.99231 21.6892 5.59029 21.6892H4.42307C3.1321 21.6889 2.08023 20.6371 2.08023 19.3461C2.08023 18.0551 3.13202 17.0033 4.42307 17.0033H5.59029C5.99229 17.0033 6.33852 16.7253 6.42412 16.3365C6.762 14.8573 7.34773 13.4506 8.16423 12.151C8.37358 11.8131 8.32676 11.373 8.04464 11.0908L7.21532 10.2615C6.30041 9.35069 6.30041 7.8632 7.21532 6.95242C8.13022 6.03751 9.61359 6.03751 10.5285 6.95242L11.3578 7.78174C11.6399 8.06386 12.0804 8.11098 12.418 7.89715C13.7135 7.08065 15.1199 6.49914 16.6035 6.16155C16.9927 6.07178 17.2661 5.72556 17.2661 5.32772V4.1605C17.2661 2.86922 18.3179 1.81743 19.609 1.81743C20.9 1.81743 21.9518 2.86922 21.9518 4.16027V5.32749C21.9518 5.72501 22.2297 6.07125 22.6186 6.16132C24.0978 6.4992 25.5045 7.08042 26.8041 7.89692C27.142 8.11075 27.5821 8.06363 27.8643 7.78151L28.6895 6.95219C29.6044 6.03728 31.0923 6.03728 32.0027 6.95219C32.4473 7.39266 32.691 7.98253 32.691 8.60672C32.691 9.2309 32.4473 9.82074 32.0027 10.2612L31.1733 11.0906C30.8912 11.3727 30.8441 11.8131 31.0579 12.1508C31.8744 13.4462 32.4559 14.8571 32.7935 16.3362C32.8833 16.7254 33.2295 17.003 33.6274 17.003H34.7946C36.0856 17.003 37.1374 18.0548 37.1374 19.3459C37.1377 20.6372 36.0859 21.6889 34.7946 21.6889Z"
                          fill="#1C462C"
                        />
                        <path
                          d="M23.5513 16.1478C23.5513 16.618 23.9319 17.0027 24.4063 17.0027C24.8766 17.0027 25.2613 16.618 25.2613 16.1478C25.2613 13.4715 23.0852 11.2954 20.4089 11.2954C19.9386 11.2954 19.554 11.6801 19.554 12.1504C19.554 12.6248 19.9387 13.0054 20.4089 13.0054C22.1404 13.0054 23.5513 14.4163 23.5513 16.1478Z"
                          fill="#AB8F5B"
                        />
                        <path
                          d="M25.2055 21.689C24.7311 21.689 24.3506 22.0696 24.3506 22.544C24.3506 24.2755 22.9397 25.6821 21.2082 25.6821C20.738 25.6821 20.3533 26.0668 20.3533 26.5371C20.3533 27.0116 20.738 27.3921 21.2082 27.3921C23.8845 27.3921 26.0606 25.216 26.0606 22.5439C26.0606 22.0695 25.6758 21.689 25.2055 21.689Z"
                          fill="#AB8F5B"
                        />
                        <path
                          d="M15.6115 20.8884C13.88 20.8884 12.4734 19.4776 12.4734 17.7461C12.4734 17.2716 12.0887 16.8911 11.6184 16.8911C11.1439 16.8911 10.7634 17.2716 10.7634 17.7461C10.7634 20.4223 12.9395 22.5984 15.6116 22.5984C16.086 22.5984 16.4665 22.2137 16.4665 21.7435C16.4665 21.269 16.086 20.8885 15.6116 20.8885L15.6115 20.8884Z"
                          fill="#AB8F5B"
                        />
                      </svg>
                    </div>
                    <div class="label">Cancer</div>
                  </div>
                  <div class="check-icon flex-mid">
                    <svg
                      width="19"
                      height="15"
                      viewBox="0 0 19 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                        stroke="white"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="mock-time-card flex-mid">
                <div
                  @click="
                    form.diseaseFamily.diabetes = !form.diseaseFamily.diabetes
                  "
                  :class="`time-card flex-mid ${
                    form.diseaseFamily.diabetes ? 'select' : ''
                  }`"
                >
                  <div class="content">
                    <div class="icon flex-mid">
                      <svg
                        width="28"
                        height="43"
                        viewBox="0 0 28 43"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.3087 30.9902V39.8933C11.3087 41.1873 12.3577 42.2363 13.6516 42.2363V42.2363C14.9456 42.2363 15.9946 41.1873 15.9946 39.8933V30.9902"
                          stroke="#1C462C"
                          stroke-width="1.5"
                        />
                        <path
                          d="M1 6C1 3.23858 3.23858 1 6 1H21.3035C24.065 1 26.3035 3.23858 26.3035 6V18.3376C26.3035 25.325 20.6391 30.9894 13.6518 30.9894V30.9894C6.66439 30.9894 1 25.325 1 18.3376V6Z"
                          stroke="#1C462C"
                          stroke-width="1.5"
                        />
                        <rect
                          x="5.68567"
                          y="6.62354"
                          width="15.9319"
                          height="8.43451"
                          rx="2"
                          stroke="#AB8E5A"
                          stroke-width="1.5"
                        />
                        <rect
                          x="5.68567"
                          y="19.7427"
                          width="5.62301"
                          height="2.8115"
                          rx="1"
                          fill="#1C462C"
                        />
                        <rect
                          x="15.9948"
                          y="19.7427"
                          width="5.62301"
                          height="2.8115"
                          rx="1"
                          fill="#1C462C"
                        />
                      </svg>
                    </div>
                    <div class="label">Diabetes</div>
                  </div>
                  <div class="check-icon flex-mid">
                    <svg
                      width="19"
                      height="15"
                      viewBox="0 0 19 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                        stroke="white"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="mock-time-card flex-mid">
                <div
                  @click="
                    form.diseaseFamily.hypertension =
                      !form.diseaseFamily.hypertension
                  "
                  :class="`time-card flex-mid ${
                    form.diseaseFamily.hypertension ? 'select' : ''
                  }`"
                >
                  <div class="content">
                    <div class="icon flex-mid">
                      <svg
                        width="46"
                        height="37"
                        viewBox="0 0 46 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.4545 27.3218C25.4534 29.8905 23.7577 32.086 21.5817 33.6307C19.4058 35.1755 16.8475 36 14.2304 36C11.6133 36 9.05501 35.1755 6.87909 33.6307C4.70317 32.086 3.0074 29.8905 2.00628 27.3218C1.00516 24.7531 0.743658 21.9268 1.25486 19.2002C1.76606 16.4736 3.65152 14.2576 5.24242 12.1364L14.2304 1L21.5817 10.5455"
                          stroke="#264E35"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.6061 17.1741H19.8511L22.4896 21.6817L28.0962 12.6665L33.5253 26.4544L35.9607 20.8862H44.4849"
                          stroke="#AA8E5B"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.3517 29.4798C12.3517 28.9766 11.9481 28.573 11.4449 28.573C9.60851 28.573 8.11663 27.0767 8.11663 25.2403C8.11663 24.7415 7.70861 24.3335 7.20984 24.3335C6.70662 24.3335 6.30304 24.7415 6.30304 25.2403C6.30304 28.0787 8.61103 30.3867 11.445 30.3867C11.9482 30.3867 12.3518 29.9787 12.3518 29.4799L12.3517 29.4798Z"
                          fill="#264E35"
                        />
                      </svg>
                    </div>
                    <div class="label">Hypertension</div>
                  </div>
                  <div class="check-icon flex-mid">
                    <svg
                      width="19"
                      height="15"
                      viewBox="0 0 19 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                        stroke="white"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="mock-time-card flex-mid">
                <div
                  @click="
                    form.diseaseFamily.cardiovascular =
                      !form.diseaseFamily.cardiovascular
                  "
                  :class="`time-card flex-mid ${
                    form.diseaseFamily.cardiovascular ? 'select' : ''
                  }`"
                >
                  <div class="content">
                    <div class="icon flex-mid">
                      <svg
                        width="45"
                        height="36"
                        viewBox="0 0 45 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 16.8H14.988L19.1325 9L25.3494 22L30.012 12.64L32.0843 16.8H44"
                          stroke="#AA8E5A"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M38.7234 19.4957C38.7436 19.4957 38.7618 19.5078 38.7696 19.5265C38.7774 19.5451 38.7732 19.5666 38.7589 19.5809L23.6867 34.7637C23.3076 35.1454 22.6929 35.1454 22.3139 34.7637L7.24162 19.5809C7.2274 19.5666 7.22319 19.5451 7.23095 19.5265C7.23871 19.5078 7.25692 19.4957 7.27711 19.4957H9.88068C9.894 19.4957 9.90678 19.501 9.91616 19.5105L23.0031 32.6933L36.0851 19.5105C36.0945 19.501 36.1072 19.4957 36.1206 19.4957H38.7234ZM4.22448 14.0321C4.20076 14.0321 4.18031 14.0154 4.17551 13.9922C3.4634 10.5388 4.43785 6.80255 7.0989 4.12196C11.2974 -0.10732 18.1049 -0.10732 22.3033 4.12196C22.594 4.41482 22.7783 4.62604 22.8902 4.76456C22.9432 4.83012 22.9799 4.87942 23.0041 4.91341L23.0378 4.87251C23.0853 4.81509 23.1514 4.73567 23.2261 4.64764C23.3751 4.47197 23.5592 4.26069 23.6967 4.12199L23.6967 4.12196C27.8952 -0.10732 34.7027 -0.10732 38.9011 4.12196C41.5621 6.80245 42.5366 10.5388 41.8245 13.9922C41.8197 14.0154 41.7993 14.0321 41.7755 14.0321H39.8866C39.8712 14.0321 39.8567 14.025 39.8472 14.0128C39.8377 14.0006 39.8344 13.9848 39.8381 13.9699C40.5765 11.037 39.8063 7.79836 37.5284 5.50384C34.0879 2.03812 28.5099 2.03812 25.0697 5.50384C24.5919 5.9855 24.1751 6.51387 23.823 7.08034C23.4428 7.6928 22.5575 7.69279 22.1774 7.08032C21.8257 6.51382 21.4089 5.9855 20.9307 5.50384C17.4902 2.03812 11.9122 2.03812 8.47203 5.50384C6.1941 7.79846 5.42397 11.0371 6.16225 13.9699C6.16601 13.9848 6.16267 14.0006 6.1532 14.0128C6.14372 14.025 6.12917 14.0321 6.11376 14.0321H4.22448Z"
                          fill="#264E35"
                          stroke="#264E35"
                          stroke-width="0.1"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div class="label">Cardiovascular</div>
                  </div>
                  <div class="check-icon flex-mid">
                    <svg
                      width="19"
                      height="15"
                      viewBox="0 0 19 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                        stroke="white"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div> -->
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextDiseaseFamily"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <!-- <div
      v-else-if="step == 'question_activity'"
      class="center activity-container"
    >
      <div class="form-container body">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-DBAdmanX fs-38' : 'fs-22'
          }`"
          style="width: 100%"
        >
          {{ $t("mainReason") }}
        </div>
        <div class="p2-10 m-auto pt-34" style="width: 25rem">
          <div
            :class="`btn-select flex-mid ${
              form.activity == 'More_active' ? 'select' : ''
            }`"
            @click="(form.activity = 'More_active'), checkActivityValidate()"
          >
            {{ $t("moreActive") }}
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`btn-select flex-mid ${
              form.activity == 'Lose_weight' ? 'select' : ''
            }`"
            @click="(form.activity = 'Lose_weight'), checkActivityValidate()"
          >
            {{ $t("loseWeight") }}
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`btn-select flex-mid ${
              form.activity == 'Active_track' ? 'select' : ''
            }`"
            @click="(form.activity = 'Active_track'), checkActivityValidate()"
          >
            {{ $t("activeTrack") }}
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`btn-select flex-mid ${
              form.activity == 'Overall_health' ? 'select' : ''
            }`"
            @click="(form.activity = 'Overall_health'), checkActivityValidate()"
          >
            {{ $t("overallHealth") }}
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextActivity"
          :class="{
            disable: formValidate.activity,
          }"
          style="width: 14rem"
          class="btn-48 btn-primary btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div> -->
    <div
      v-else-if="step == 'question_exercise_week'"
      class="center exercise-week-container"
    >
      <div class="form-container body">
        <div
          :class="`question-title ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("exercise") }}
        </div>
        <div class="selec-contariner">
          <div
            @click="selectExercise('<3 days/week')"
            :class="`option-box flex-mid ${
              form.days_a_week_do_exercise == '<3 days/week' ? 'selected' : ''
            }`"
          >
            <div style="text-align: center">{{ $t("lessThan3day") }}</div>
          </div>
          <div
            @click="selectExercise('3-5 days/week')"
            :class="`option-box flex-mid ${
              form.days_a_week_do_exercise == '3-5 days/week' ? 'selected' : ''
            }`"
          >
            <div style="text-align: center">{{ $t("d3To5") }}</div>
          </div>
          <div
            @click="selectExercise('6-7 days/week')"
            :class="`option-box flex-mid ${
              form.days_a_week_do_exercise == '6-7 days/week' ? 'selected' : ''
            }`"
          >
            <div style="text-align: center">{{ $t("d6To7") }}</div>
          </div>
          <div
            @click="selectExercise('I don’t do exercise')"
            :class="`option-box flex-mid ${
              form.days_a_week_do_exercise == 'I don’t do exercise'
                ? 'selected'
                : ''
            }`"
          >
            <div class="center">
              <div style="text-align: center">{{ $t("dontdo") }}</div>
            </div>
          </div>
          <!-- <div
            @click="form.days_a_week_do_exercise = ''"
            :class="`check-icon flex-mid ${
              form.days_a_week_do_exercise ? 'select' : ''
            }`"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.42847 1.42871L6.57132 6.57157M6.57132 6.57157L11.7142 11.7144M6.57132 6.57157L11.7142 1.42871M6.57132 6.57157L1.42847 11.7144"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div> -->
          <!-- <div
            :class="`option-box-mid absolute-mid flex-mid ${
              form.days_a_week_do_exercise ? 'select' : ''
            }`"
          >
            <p v-if="form.days_a_week_do_exercise == ''">{{ $t("select") }}</p>
          </div> -->
        </div>
        <div
          v-if="
            form.days_a_week_do_exercise != 'I don’t do exercise' &&
            form.days_a_week_do_exercise
          "
          class="center mt-20 mb-10"
        >
          <div class="fs-18 fw-500 center">
            {{ $t("exercisetime") }}
          </div>
          <div class="relative mt-16">
            <div class="absolute-mid focus-bg-exercise"></div>
            <div class="absolute-mid top-bottom-bg-exercise"></div>
            <swiper
              :direction="'vertical'"
              :initial-slide="form.exercise"
              @slideChange="onSlideExercisePerTimeChange"
              :slides-per-view="3"
              :centeredSlides="true"
              :grabCursor="true"
              class="exercise-selected-exercise"
            >
              <!-- {{ form.exercise }} -->
              <swiper-slide
                v-for="value in exercisePerWeekOption"
                :id="value.value"
                :key="value.index"
              >
                <div
                  v-if="lang == 'th'"
                  class="flex-mid fc-DBDBDB fs-16 fw-500"
                  style="height: 4.8rem"
                >
                  {{ value.label_th }}
                </div>
                <div
                  v-else
                  class="flex-mid fc-DBDBDB fs-16 fw-500"
                  style="height: 4.8rem"
                >
                  {{ value.label_en }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextExerciseWeek"
          :class="{
            disable: formValidate.days_a_week_do_exercise,
          }"
          style="width: 14rem"
          class="btn-48 btn-question btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div>
    <!-- <div v-else-if="step == 'question_sports'" class="center sports-container">
      <div class="form-container">
        <div class="body">
          <div
            :class="`question-title ${
              lang == 'th' ? 'font-DBAdmanX fs-38' : 'fs-22'
            }`"
          >
            {{ $t("sportsTrain") }}
          </div>
          <div class="flex-center pt-40">
            <div
              @click="form.sport = true"
              :class="`sports-btn flex-mid mt-22 ml-auto ${
                form.sport == true ? 'select' : ''
              }`"
            >
              <div class="label">
                <div class="mt-6">
                  <svg
                    width="38"
                    height="28"
                    viewBox="0 0 38 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37.0624 1.18739C37.5012 1.62683 37.7477 2.22255 37.7477 2.84364C37.7477 3.46473 37.5012 4.06042 37.0624 4.49989L14.4062 27.1561C13.9667 27.5949 13.371 27.8415 12.7499 27.8415C12.1288 27.8415 11.5331 27.5949 11.0936 27.1561L0.937401 16.9999C0.523401 16.5556 0.298026 15.968 0.308713 15.3607C0.319432 14.7535 0.5654 14.1742 0.994838 13.7448C1.42424 13.3154 2.00359 13.0694 2.61078 13.0587C3.21796 13.048 3.80559 13.2734 4.2499 13.6874L12.7499 22.1874L33.7499 1.18739C34.1893 0.748484 34.7849 0.501953 35.4062 0.501953C36.0271 0.501953 36.623 0.748484 37.0624 1.18739Z"
                      fill="#6DB557"
                    />
                  </svg>
                </div>
                <div class="mt-8">{{ $t("yes") }}</div>
              </div>
            </div>
            <div
              @click="form.sport = false"
              :class="`sports-btn flex-mid mt-22 ml-auto ${
                form.sport == false ? 'select' : ''
              }`"
            >
              <div class="label">
                <div class="mt-6">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.62489 1.62487C2.06433 1.18596 2.66005 0.939428 3.28114 0.939428C3.90223 0.939428 4.49792 1.18596 4.93739 1.62487L14.9999 11.6874L25.0624 1.62487C25.2771 1.39458 25.5358 1.2099 25.8233 1.0818C26.1108 0.95371 26.4211 0.884835 26.7358 0.879272C27.0505 0.87371 27.363 0.931616 27.6549 1.04949C27.9468 1.16737 28.2118 1.3428 28.4343 1.56537C28.6571 1.78793 28.8324 2.05305 28.9502 2.34487C29.068 2.63671 29.1261 2.9493 29.1205 3.26399C29.1149 3.57871 29.0461 3.88905 28.918 4.17655C28.7899 4.46405 28.6052 4.7228 28.3749 4.93737L18.3124 14.9999L28.3749 25.0624C28.6052 25.2771 28.7899 25.5358 28.918 25.8233C29.0461 26.1108 29.1149 26.4211 29.1205 26.7358C29.1261 27.0505 29.068 27.363 28.9502 27.6549C28.8324 27.9467 28.6571 28.2117 28.4343 28.4342C28.2118 28.6571 27.9468 28.8324 27.6549 28.9502C27.363 29.068 27.0505 29.1261 26.7358 29.1205C26.4211 29.1149 26.1108 29.0461 25.8233 28.918C25.5358 28.7899 25.2771 28.6052 25.0624 28.3749L14.9999 18.3124L4.93739 28.3749C4.49308 28.7889 3.90542 29.0142 3.29823 29.0036C2.69105 28.9927 2.11173 28.7467 1.6823 28.3174C1.25289 27.888 1.00692 27.3086 0.996203 26.7014C0.985485 26.0942 1.21089 25.5067 1.62489 25.0624L11.6874 14.9999L1.62489 4.93737C1.18598 4.49793 0.939453 3.90221 0.939453 3.28112C0.939453 2.66002 1.18598 2.06433 1.62489 1.62487Z"
                      fill="#6DB557"
                    />
                  </svg>
                </div>
                <div class="mt-8">{{ $t("no") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextSport"
          :class="{
            disable: formValidate.sport,
          }"
          style="width: 14rem"
          class="btn-48 btn-primary btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div> -->
    <div v-else-if="step == 'question_finish'" class="center finish-container">
      <div class="form-container">
        <div class="body flex-mid">
          <div class="center">
            <img
              src="@/assets/image/Question/finish.gif"
              alt=""
              class="mx-auto"
              style="
                width: 100%;
                max-width: 19rem;
                height: 100%;
                object-fit: scale-down;
              "
            />
            <div class="fs-24 fc-545454">Finish!</div>
            <!-- <div class="fc-545454 fs-14 fw-500">Link your patient profile</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div v-if="step == 'Sync_data_dialog'" class="footer">
    <div class="bottom-screen">
      <div class="mx-auto footer-modal">
        <div class="flex-center">
          <div
            class="ml-auto cursor-pointer"
            @click="(step = 'let_start'), (shadowScreen = false)"
          >
            <svg
              width="17"
              height="17" 
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.413479 0.449024C0.678563 0.184828 1.03792 0.0364306 1.41259 0.0364306C1.78725 0.0364306 2.14659 0.184828 2.41169 0.449024L8.48173 6.50606L14.5518 0.449024C14.6813 0.310408 14.8374 0.199237 15.0108 0.122132C15.1842 0.0450273 15.3714 0.00356856 15.5612 0.000220264C15.7511 -0.00312803 15.9396 0.0317282 16.1157 0.102682C16.2917 0.173636 16.4516 0.279239 16.5858 0.413208C16.7202 0.547178 16.826 0.706768 16.897 0.882422C16.9681 1.05809 17.0032 1.24626 16.9998 1.43568C16.9964 1.62512 16.9549 1.81193 16.8776 1.98499C16.8003 2.15805 16.6889 2.3138 16.55 2.44295L10.4799 8.49999L16.55 14.557C16.6889 14.6863 16.8003 14.842 16.8776 15.0151C16.9549 15.1881 16.9964 15.3749 16.9998 15.5643C17.0032 15.7538 16.9681 15.9419 16.897 16.1176C16.826 16.2932 16.7202 16.4528 16.5858 16.5867C16.4516 16.7208 16.2917 16.8263 16.1157 16.8973C15.9396 16.9682 15.7511 17.0032 15.5612 16.9998C15.3714 16.9964 15.1842 16.955 15.0108 16.8779C14.8374 16.8008 14.6813 16.6896 14.5518 16.551L8.48173 10.4939L2.41169 16.551C2.14367 16.8002 1.78917 16.9358 1.4229 16.9294C1.05662 16.9228 0.70716 16.7748 0.448109 16.5163C0.189076 16.2579 0.0406996 15.9091 0.0342337 15.5436C0.0277678 15.1782 0.163741 14.8245 0.413479 14.557L6.48352 8.49999L0.413479 2.44295C0.148716 2.17844 0 1.81985 0 1.44599C0 1.07213 0.148716 0.713558 0.413479 0.449024Z"
                fill="#B0B0B0"
              />
            </svg>
          </div>
        </div>
        <div class="fs-18 fw-500">{{ $t("syncData") }}</div>
        <div class="flex-mid mt-20">
          <div
            @click="getSyncData()"
            style="width: 14rem"
            class="btn-48 btn-primary btn mx-auto mr-10"
          >
            {{ $t("yesSync") }}
          </div>
          <div
            @click="skipSyncData()"
            style="width: 14rem"
            class="btn-48 btn-second btn mr-auto ml-10"
          >
            {{ $t("noSync") }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="remove-padding-dialog">
    <el-dialog v-model="getDataDialog" width="35.5rem">
      <div class="center p-28">
        <div class="mt-40 fc-000000 fs-16">
          ผลจากสมิติเวช ณ วันที่ {{ dataSync.data }}
        </div>
        <div class="flex-mid mt-40">
          <div
            @click="useDataDialog()"
            style="width: 14rem"
            class="btn-48 btn-primary btn mx-auto mr-10"
          >
            Yes
          </div>
          <div
            @click="skipSyncData()"
            style="width: 14rem"
            class="btn-48 btn-second btn mr-auto ml-10"
          >
            No
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-model="dataNotFoundDialog" width="35.5rem">
      <div class="center p-28">
        <div class="mt-40 fc-000000 fs-16">ไม่พบข้อมูล</div>
        <div class="flex-mid mt-40">
          <div
            @click="startQuestion()"
            style="width: 14rem"
            class="btn-48 btn-primary btn"
          >
            Yes
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { defineComponent } from "vue";
// import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { Mousewheel } from "swiper";
import axios from "axios";
import * as config from "@/assets/js/config.js";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import "swiper/swiper.min.css";
import "swiper/modules/autoplay/autoplay.scss";
import "swiper/modules/navigation/navigation.scss"; // Navigation module
import "swiper/modules/pagination/pagination.scss"; // Pagination module

export default defineComponent({
  name: "Question",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Mousewheel],
    };
  },
  data() {
    return {
      step: "let_start", // let_start
      shadowScreen: false,
      getDataDialog: false,
      dataNotFoundDialog: false,
      accessToken: null,
      otherClickNext: false,
      lang: "th",
      isLeapYear: false,
      options: {
        month: [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
        ],
        career: [
          "ผู้บริหาร",
          "ธุรกิจส่วนตัว",
          "พนักงานรัฐ",
          "พนักงานบริษัท",
          "นักกีฬา",
          "ว่างงาน",
          "นักเรียน/นักศึกษา",
          "อื่นๆ",
        ],
      },
      exercisePerWeekOption: [
        {
          label_th: "น้อยกว่า 15 นาที",
          label_en: "Less than 15 minutes",
          id: "less than 15 minutes per day",
          index: 0,
        },
        {
          label_th: "15 - 30 นาที",
          label_en: "15-30 minutes",
          id: "15-30 minutes per day",
          index: 1,
        },
        {
          label_th: "30 - 60 นาที",
          label_en: "30-60 minutes",
          id: "30-60 minutes per day",
          index: 2,
        },
        {
          label_th: "มากกว่า 60 นาที",
          label_en: "More than 60 minutes",
          id: "more than 1 hour",
          index: 4,
        },
      ],
      dataSync: {
        data: "",
      },
      form: {
        ssid: "",
        sex: "M",
        birthDate: "2000-01-01",
        dayOfBirth: "1",
        monthOfBirth: "1",
        yearOfBirth: "2000",
        career: "",
        careerInput: "",
        height: "",
        weight: "",
        BMI: "",
        waistline: "",
        bloodPressureHigher: "",
        bloodPressureLower: "",
        cholesterol: "",
        bloodSugar: "",
        behavior: {
          snoring: false,
          alcohol: false,
          exercise: false,
          healthCheck: false,
          nothealthCheck: false,
          smoking: false,
        },
        disease: {
          none: false,
          cancer: false,
          diabetes: false,
          hypertension: false,
          cardiovascular: false,
          kidney: false,
          other: false,
          otherData: "",
        },
        diseaseFamily: {
          cancer: false,
          diabetes: false,
          hypertension: false,
          cardiovascular: false,
          kidney: false,
          other: "",
        },
        days_a_week_do_exercise: "",
        exercise: 0,
        activity: "",
        sport: null,
      },
      formValidate: {
        career: false,
        careerInput: false,
        height: false,
        weight: false,
        waistline: false,
        activity: false,
        days_a_week_do_exercise: false,
        exercise: false,
        sport: false,
        dayOfBirth: false,
        monthOfBirth: false,
        yearOfBirth: false,
      },
      exercisePerTime: [
        "less than 15 minutes per day",
        "15-30 minutes per day",
        "30-60 minutes per day",
        "more than 1 hour",
      ],
    };
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.getData();
    this.getOldData();
  },
  computed: {
    bmi() {
      if (!this.form.weight || !this.form.height) {
        return 0;
      }
      return (this.form.weight / Math.pow(this.form.height / 100.0, 2)).toFixed(
        2
      );
    },
  },
  methods: {
    onSlideExercisePerTimeChange(value) {
      console.log(this.exercisePerWeekOption[value.activeIndex]);
      // console.log(this.exercisePerWeekOption[value.activeIndex].id);

      // console.log(this.exercisePerWeekOption[value.slides[value.activeIndex].id])
      // this.form.exercise = this.exercisePerWeekOption[value.slides[value.activeIndex].id];
      console.log(value.activeIndex, typeof value.activeIndex);
      this.form.exercise = value.activeIndex;
    },
    onSlideDayChange(value) {
      this.form.dayOfBirth = value.slides[value.activeIndex].id;
    },
    onSlideMonthChange(value) {
      this.form.monthOfBirth = value.activeIndex + 1;
      // this.form.monthOfBirth = value.slides[value.activeIndex+1].id;
    },
    onSlideYearChange(value) {
      this.form.yearOfBirth = value.slides[value.activeIndex].id;
      this.checkLeapYear(value.slides[value.activeIndex].id);
    },
    checkDayOfBirthValidate() {
      this.formValidate.dayOfBirth = true;
      if (this.form.dayOfBirth) {
        this.formValidate.dayOfBirth = false;
      }
    },
    checkMonthOfBirthValidate() {
      this.formValidate.monthOfBirth = true;
      if (this.form.monthOfBirth) {
        this.formValidate.monthOfBirth = false;
      }
    },
    checkYearOfBirthValidate() {
      this.formValidate.yearOfBirth = true;
      if (this.form.yearOfBirth) {
        this.formValidate.yearOfBirth = false;
      }
    },
    checkLeapYear(value) {
      // console.log(value)
      if (value % 4 == 0) {
        if (value % 100 == 0) {
          if (value % 400 == 0) {
            this.isLeapYear = true;
          } else {
            this.isLeapYear = false;
          }
        } else {
          this.isLeapYear = true;
        }
      } else {
        this.isLeapYear = false;
      }
      // console.log("check leap year",this.isLeapYear)
    },
    nextDateOfBirthl() {
      this.checkDayOfBirthValidate();
      this.checkMonthOfBirthValidate();
      this.checkYearOfBirthValidate();
      setTimeout(() => {
        if (
          !this.formValidate.dayOfBirth &&
          !this.formValidate.monthOfBirth &&
          !this.formValidate.yearOfBirth
        ) {
          // this.step = "question_career";
          this.step = "question_body_details";
          this.form.birthDate =
            this.form.yearOfBirth +
            "-" +
            ("0" + this.form.monthOfBirth).slice(-2) +
            "-" +
            ("0" + this.form.dayOfBirth).slice(-2);
          this.updateCustomer();
          // console.log(this.form.birthDate);
          // console.log(this.form.sex);
        }
      }, 400);
    },
    checkCareerValidate() {
      this.formValidate.career = true;
      this.formValidate.careerInput = true;
      if (this.form.career && this.form.career != "อื่นๆ") {
        this.formValidate.career = false;
        this.formValidate.careerInput = false;
      } else if (this.form.career == "อื่นๆ") {
        this.formValidate.career = false;
        if (this.form.careerInput) {
          this.formValidate.careerInput = false;
        }
      } else {
        this.formValidate.careerInput = false;
      }
    },
    checkBloodPressureHeight() {
      // this.form.bloodPressureHigher
      let bloodHigher = this.form.bloodPressureHigher;
      if (bloodHigher.length > 3) {
        bloodHigher = bloodHigher.slice(0, 3);
        this.form.bloodPressureHigher = bloodHigher;
      }
      console.log(this.form.bloodPressureHigher);
    },
    checkBloodPressureLow() {
      // this.form.bloodPressureHigher
      let bloodLower = this.form.bloodPressureLower;
      if (bloodLower.length > 3) {
        bloodLower = bloodLower.slice(0, 3);
        this.form.bloodPressureLower = bloodLower;
      }
      console.log(this.form.bloodPressureHigher);
    },
    checkCholesterol() {
      // this.form.bloodPressureHigher
      let cholesterol = this.form.cholesterol;
      if (cholesterol.length > 6) {
        cholesterol = cholesterol.slice(0, 6);
        this.form.cholesterol = cholesterol;
      }
      console.log(this.form.cholesterol);
    },
    checkBloodGlucose() {
      // this.form.bloodPressureHigher
      let bloodSugar = this.form.bloodSugar;
      if (bloodSugar.length > 6) {
        bloodSugar = bloodSugar.slice(0, 6);
        this.form.bloodSugar = bloodSugar;
      }
      console.log(this.form.cholesterol);
    },
    nextCareerForm() {
      this.checkCareerValidate();
      if (!this.formValidate.career && !this.formValidate.careerInput) {
        // this.sendForm(
        //   9,
        //   this.form.career == "อื่นๆ" ? this.form.careerInput : this.form.career
        // );
        this.step = "question_body_details";
      }
    },
    checkHeightValidate() {
      this.formValidate.height = true;
      let height = this.form.height;
      // if (height.length > 3) {
      //   height = height.slice(0, 2);
      //   this.form.height = height + 0;
      // }
      // console.log("check height",this.form.height)
      parseInt(height.toString().replace(/\./, ""));

      // if (!/^[1-9][0-9]*$/.test(this.form.height)){
      // // if (/[\.]/.test(this.form.height)){
      //   this.form.height = '';
      // }

      if (height.length > 3) {
        height = height.slice(0, 2);
        this.form.height = height + 0;
      }
      if (this.form.height) {
        this.formValidate.height = false;
      }
    },
    checkWeightValidate() {
      let weight = this.form.weight;
      this.formValidate.weight = true;

      if (weight.length > 3) {
        weight = weight.slice(0, 2);
        this.form.weight = weight + 0;
      }
      if (this.form.weight) {
        this.formValidate.weight = false;
      }
    },
    checkWaistlineValidate() {
      this.formValidate.waistline = true;
      let waistline = this.form.waistline;
      if (waistline.length > 3) {
        this.form.waistline = this.form.waistline.slice(0, 2);
      }
      if (this.form.waistline) {
        this.formValidate.waistline = false;
      }
    },
    nextBodyDetail() {
      this.checkHeightValidate();
      this.checkWeightValidate();
      this.checkWaistlineValidate();
      setTimeout(() => {
        if (
          !this.formValidate.height &&
          !this.formValidate.weight &&
          !this.formValidate.waistline
        ) {
          // this.sendForm(1, this.form.height);
          // this.sendForm(2, this.form.weight);
          // this.sendForm(3, this.bmi);
          // this.sendForm(4, this.form.waistline);
          this.step = "question_health";
        }
      }, 400);
    },
    nextHealthDetail() {
      // if (this.form.bloodPressureHigher) {
      //   this.sendForm(5, this.form.bloodPressureHigher);
      // }
      // if (this.form.bloodPressureLower) {
      //   this.sendForm(6, this.form.bloodPressureLower);
      // }
      // if (this.form.cholesterol) {
      //   this.sendForm(7, this.form.cholesterol);
      // }
      // if (this.form.bloodSugar) {
      //   this.sendForm(8, this.form.bloodSugar);
      // }
      this.step = "question_behavior";
    },
    nextBehavior() {
      // this.sendForm(22, this.form.behavior.healthCheck);
      // this.sendForm(65, this.form.behavior.nothealthCheck);
      // this.sendForm(10, this.form.behavior.alcohol);
      // this.sendForm(11, this.form.behavior.smoking);
      // this.sendForm(13, this.form.behavior.snoring);
      this.step = "question_disease";
    },
    checkActivityValidate() {
      this.formValidate.activity = true;
      if (this.form.activity) {
        this.formValidate.activity = false;
      }
    },
    nextActivity() {
      this.checkActivityValidate();
      if (!this.formValidate.activity) {
        // this.sendForm(48, this.form.activity);
        this.step = "question_exercise_week";
      }
    },
    checkDisease() {
      this.formValidate.question_disease_family = true;
      if (
        this.form.disease.none == true ||
        this.form.disease.cancer == true ||
        this.form.disease.diabetes == true ||
        this.form.disease.hypertension == true ||
        this.form.disease.cardiovascular == true ||
        this.form.disease.kidney == true ||
        this.form.disease.none == true ||
        this.form.disease.other == true
      ) {
        if (this.form.disease.other == true) {
          if (this.form.disease.otherData) {
            this.formValidate.question_disease_family = false;
          } else {
            this.otherClickNext = true;
          }
        } else {
          this.formValidate.question_disease_family = false;
          this.otherClickNext = false;
        }
      }
    },
    nextDisease() {
      this.checkDisease();
      if (!this.formValidate.question_disease_family) {
        // this.sendForm(14, this.form.disease.diabetes);
        // this.sendForm(16, this.form.disease.hypertension);
        // this.sendForm(18, this.form.disease.cardiovascular);
        // this.sendForm(20, this.form.disease.cancer);
        // this.sendForm(42, this.form.disease.kidney);
        // this.sendForm(47, this.form.disease.otherData);
        // this.sendForm(49, this.form.disease.none);

        this.step = "question_disease_family";
      }
    },
    nextDiseaseFamily() {
      // this.sendForm(15, this.form.diseaseFamily.diabetes);
      // this.sendForm(17, this.form.diseaseFamily.hypertension);
      // this.sendForm(19, this.form.diseaseFamily.cardiovascular);
      // this.sendForm(21, this.form.diseaseFamily.cancer);
      // this.sendForm(43, this.form.diseaseFamily.kidney);
      // this.step = "question_activity";
      this.step = "question_exercise_week";
    },
    checkExerciseWeek() {
      this.formValidate.days_a_week_do_exercise = true;
      if (this.form.days_a_week_do_exercise) {
        this.formValidate.days_a_week_do_exercise = false;
      }
    },
    nextExerciseWeek() {
      this.checkExerciseWeek();
      // setTimeout(() => {
      if (!this.formValidate.days_a_week_do_exercise) {
        // this.sendForm(40, this.form.days_a_week_do_exercise);
        if (this.form.days_a_week_do_exercise == "I don’t do exercise") {
          // this.step = "question_sports";
          this.step = "question_finish";
          this.submitForm();
        } else {
          console.log(this.form.exercise);
          // this.sendForm(41, this.exercisePerTime[this.form.exercise]);
          this.step = "question_finish";
          this.submitForm();
          // this.step = "question_sports";
        }
      }
      // }, 400);
    },
    checkExerciseTime() {
      this.formValidate.exercise = true;
      if (this.form.exercise) {
        this.formValidate.exercise = false;
      }
    },
    nextExerciseTime() {
      this.checkExerciseTime();
      // setTimeout(() => {
      if (!this.formValidate.exercise) {
        console.log(this.exercisePerTime[this.form.exercise]);
        // this.sendForm(41, this.exercisePerTime[this.form.exercise]);
        // this.sendForm(40, this.exercisePerWeekId[this.form.exercisePerWeek]);
        // this.step = "question_sports";
        this.step = "question_finish";
      }
      // }, 400);
    },
    checkSport() {
      this.formValidate.sport = true;
      if (this.form.sport) {
        this.formValidate.sport = false;
      }
    },
    nextSport() {
      this.checkSport();
      // setTimeout(() => {
      if (!this.form.sport) {
        // this.sendForm(46, this.form.sport);
        this.submitForm();
      }
      // }, 400);
    },
    letStart() {
      // if(!this.form.ssid){
      //   this.shadowScreen = true;
      //   this.step = "Sync_data_dialog";
      //   this.dataSync = {
      //     data: "02 / 03/ 2022",
      //   };
      // }else{
      this.shadowScreen = false;
      this.step = "question_sex";
      this.getDataDialog = false;
      this.dataNotFoundDialog = false;
      // }
    },
    getSyncData() {
      this.shadowScreen = false;
      this.step = "let_start";
      this.getDataDialog = true;
    },
    skipSyncData() {
      this.shadowScreen = false;
      this.step = "question_sex";
      this.getDataDialog = false;
      this.dataNotFoundDialog = false;
    },
    useDataDialog() {
      this.getDataDialog = false;
      this.dataNotFoundDialog = true;
    },
    startQuestion() {
      this.dataNotFoundDialog = false;
      this.step = "question_sex";
    },
    switchSex() {
      if (this.form.sex == "M") {
        this.form.sex = "F";
      } else {
        this.form.sex = "M";
      }
    },
    selectExercise(value) {
      if (value == this.form.days_a_week_do_exercise) {
        this.form.days_a_week_do_exercise = "";
      } else {
        this.form.days_a_week_do_exercise = value;
      }
      this.checkExerciseWeek();
    },
    getArrForYears() {
      const date = new Date();
      const year = date.getFullYear();
      // if(this.lang=='th'){
      //    year = date.getFullYear()+543;
      // }
      // else{
      //  year = date.getFullYear();
      // }

      const arr = [];
      for (let i = year - 110; i < year; i++) {
        arr.unshift(i);
      }
      // console.log("select year",arr)
      return arr;
    },
    backBTN() {
      // --- value of page ---
      // let_start
      // Sync_data_dialog
      // question_sex
      // question_career
      // question_body_details
      // question_health
      // question_behavior
      // question_disease
      // question_disease_family
      // question_activity
      // question_exercise_week
      // question_sports
      // question_finish
      let step = this.step;
      if (step == "question_sex") {
        step = "let_start";
      }
      //  else if (step == "question_career") {
      //   step = "question_sex";
      // }
      else if (step == "question_body_details") {
        // step = "question_career";
        step = "question_sex";
      } else if (step == "question_health") {
        step = "question_body_details";
      } else if (step == "question_behavior") {
        step = "question_health";
      } else if (step == "question_disease") {
        step = "question_behavior";
      } else if (step == "question_disease_family") {
        step = "question_disease";
      }
      // else if (step == "question_activity") {
      //   step = "question_disease_family";
      // }
      else if (step == "question_exercise_week") {
        // step = "question_activity";
        step = "question_disease_family";
      }
      // else if (step == "question_sports") {
      //   step = "question_exercise_week";
      // }
      else if (step == "question_finish") {
        // step = "question_sports";
        step = "question_exercise_week";
      }
      return step;
    },
    returnMockArray(value) {
      let arr = [];
      for (let i = 0; i < value; i++) {
        arr.push("mock_step" + i);
      }
      return arr;
    },
    showStepValue() {
      let step = "";
      switch (this.step) {
        case "question_sex":
          step = 1;
          break;
        // case "question_career":
        //   step = 2;
        //   break;
        case "question_body_details":
          step = 2;
          break;
        case "question_health":
          step = 3;
          break;
        case "question_behavior":
          step = 4;
          break;
        case "question_disease":
          step = 5;
          break;
        case "question_disease_family":
          step = 6;
          break;
        // case "question_activity":
        //   step = 8;
        //   break;
        case "question_exercise_week":
          step = 8;
          break;
        // case "question_sports":
        //   step = 9;
        //   break;
      }
      return step;
    },
    showBackBTN() {
      const stepArray = [
        "question_career",
        "question_body_details",
        "question_health",
        "question_behavior",
        "question_disease",
        "question_disease_family",
        // "question_activity",
        "question_exercise_week",
        // "question_sports",
        "question_finish",
      ];
      const arrayLength = stepArray.length;
      for (let i = 0; i < arrayLength; i++) {
        if (this.step == stepArray[i]) {
          return true;
        }
      }
      return false;
    },
    submitForm() {
      this.step = "question_finish";

      let reqBody = [
        {
          questionId: 1,
          answer: this.form.height,
        },
        {
          questionId: 2,
          answer: this.form.weight,
        },
        {
          questionId: 3,
          answer: this.bmi,
        },
        {
          questionId: 5,
          answer: this.form.bloodPressureHigher,
        },
        {
          questionId: 6,
          answer: this.form.bloodPressureLower,
        },
        {
          questionId: 7,
          answer: this.form.cholesterol,
        },
        {
          questionId: 8,
          answer: this.form.bloodSugar,
        },
        {
          questionId: 22,
          answer: this.form.behavior.healthCheck,
        },
        {
          questionId: 65,
          answer: this.form.behavior.nothealthCheck,
        },
        {
          questionId: 10,
          answer: this.form.behavior.alcohol,
        },
        {
          questionId: 11,
          answer: this.form.behavior.smoking,
        },
        {
          questionId: 13,
          answer: this.form.behavior.snoring,
        },
        {
          questionId: 48,
          answer: this.form.activity,
        },
        {
          questionId: 14,
          answer: this.form.disease.diabetes,
        },
        {
          questionId: 16,
          answer: this.form.disease.hypertension,
        },
        {
          questionId: 18,
          answer: this.form.disease.cardiovascular,
        },
        {
          questionId: 20,
          answer: this.form.disease.cancer,
        },
        {
          questionId: 42,
          answer: this.form.disease.kidney,
        },
        {
          questionId: 47,
          answer: this.form.disease.otherData,
        },
        {
          questionId: 49,
          answer: this.form.disease.none,
        },
        {
          questionId: 15,
          answer: this.form.diseaseFamily.diabetes,
        },
        {
          questionId: 17,
          answer: this.form.diseaseFamily.hypertension,
        },
        {
          questionId: 19,
          answer: this.form.diseaseFamily.cardiovascular,
        },
        {
          questionId: 21,
          answer: this.form.diseaseFamily.cancer,
        },
        {
          questionId: 43,
          answer: this.form.diseaseFamily.kidney,
        },
        {
          questionId: 40,
          answer: this.form.days_a_week_do_exercise,
        },
        {
          questionId: 41,
          answer: this.exercisePerTime[this.form.exercise],
        },
      ];

      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/health-assessment/inserts",
          {
            createHealthAssessmentReqBeans: reqBody,
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.$router.push("/assessment-report");
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/min/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          if (res.customer.gender != null) {
            this.form.sex = res.customer.gender;
          }
          this.form.birthDate = res.customer.birthDate;
          this.form.ssid = res.customer.ssid;
          if (this.form.birthDate) {
            const birthDate = this.form.birthDate.split("-");
            this.form.yearOfBirth = birthDate[0];
            this.form.monthOfBirth = birthDate[1];
            this.form.dayOfBirth = birthDate[2];
          }
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    getOldData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/datacenter/get",
          {
            questionnaireId: 1,
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data.questionInformations);
          let returnData = res.data.questionInformations;
          for (let i = 0; i < returnData.length; i++) {
            // console.log(returnData[i].questionId)
            switch (returnData[i].questionId) {
              case 1:
                this.form.height = Number(returnData[i].answer);
                break;
              case 2:
                this.form.weight = Number(returnData[i].answer);
                break;
              case 4:
                this.form.waistline = Number(returnData[i].answer);
                break;
              case 5:
                this.form.bloodPressureHigher = Number(returnData[i].answer);
                break;
              case 6:
                this.form.bloodPressureLower = Number(returnData[i].answer);
                break;
              case 7:
                this.form.cholesterol = Number(returnData[i].answer);
                break;
              case 8:
                this.form.bloodSugar = Number(returnData[i].answer);
                break;
              case 9:
                if (this.options.career.includes(returnData[i].answer)) {
                  this.form.career = returnData[i].answer;
                } else {
                  this.form.career = "อื่นๆ";
                  this.form.careerInput = returnData[i].answer;
                }
                break;
              case 10:
                this.form.behavior.alcohol = returnData[i].answer === "true";
                break;
              case 11:
                this.form.behavior.smoking = returnData[i].answer === "true";
                break;
              case 13:
                this.form.behavior.snoring = returnData[i].answer === "true";
                break;
              case 14:
                this.form.disease.diabetes = returnData[i].answer === "true";
                break;
              case 15:
                this.form.diseaseFamily.diabetes =
                  returnData[i].answer === "true";
                break;
              case 16:
                this.form.disease.hypertension =
                  returnData[i].answer === "true";
                break;
              case 17:
                this.form.diseaseFamily.hypertension =
                  returnData[i].answer === "true";
                break;
              case 18:
                this.form.disease.cardiovascular =
                  returnData[i].answer === "true";
                break;
              case 19:
                this.form.diseaseFamily.cardiovascular =
                  returnData[i].answer === "true";
                break;
              case 20:
                this.form.disease.cancer = returnData[i].answer === "true";
                break;
              case 21:
                this.form.diseaseFamily.cancer =
                  returnData[i].answer === "true";
                break;
              case 22:
                this.form.behavior.healthCheck =
                  returnData[i].answer === "true";
                break;
              case 40:
                this.form.days_a_week_do_exercise = returnData[i].answer;
                break;
              case 41:
                this.form.exercise = this.exercisePerTime.indexOf(
                  returnData[i].answer
                );
                break;
              case 42:
                this.form.disease.kidney = returnData[i].answer === "true";
                break;
              case 43:
                this.form.diseaseFamily.kidney =
                  returnData[i].answer === "true";
                break;
              case 46:
                this.form.sport = returnData[i].answer;
                break;
              case 47:
                this.form.disease.otherData = returnData[i].answer;
                if (this.form.disease.otherData) {
                  this.form.disease.other = true;
                }
                break;
              case 48:
                this.form.activity = returnData[i].answer;
                break;
              case 49:
                this.form.disease.none = returnData[i].answer === "true";
                break;
              case 65:
                this.form.behavior.nothealthCheck =
                  returnData[i].answer === "true";
                break;
            }
          }
        });
    },
    sendForm(questionId, answer) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/health-assessment/update",
          {
            updateHealthAssessmentReqBean: {
              questionId: questionId,
              answer: answer,
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    updateCustomer() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/update",
          {
            updateCustomerReqBean: {
              birthDate: this.form.birthDate,
              gender: this.form.sex,
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    getNewToken() {
      // 1. Generate a CognitoUser object
      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );

      const userData = {
        Username: this.$cookies.get("username"),
        Pool: this.$store.state.userPool,
      };

      const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      // 2. Generate a RefreshToken object
      var refresh_token = this.$cookies.get("refresh_token");
      const refreshToken = new AmazonCognitoIdentity.CognitoRefreshToken({
        RefreshToken: refresh_token,
      });

      cognitoUser.refreshSession(refreshToken, (err, session) => {
        if (err) {
          console.log(err);
        } else {
          this.accessToken = session.getIdToken().getJwtToken();
          this.$cookies.set("access_token", this.accessToken);
          this.$cookies.set(
            "refresh_token",
            session.getRefreshToken().getToken()
          );
          this.getData();
          this.getOldData();
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.check-icon {
  border-radius: 4.3rem;
  background-color: #6db557;
  cursor: pointer;
  transition: 0.3s;
}

.form-container {
  padding-top: 4rem;
  min-height: 60vh;

  @media only screen and (max-width: 514px) {
    min-height: 60vh;
  }
}

.questionatitle {
  width: calc(100% - 3rem);
  font-size: 1.5rem;
  margin: auto;
  margin-top: 40px;
}

.footer-btn-next {
  width: calc(100% - 3.6rem);
  max-width: 50rem;
  margin: 3rem auto;
  padding: 0 1.8rem;
}

.image-middle {
  height: 50rem;
  width: 50rem;
  max-height: 400px;
  max-width: 100vw;
}

.head-link-container {
  padding: 2rem 1.6rem 0;

  @media only screen and (max-width: 514px) {
    padding: 1.6rem;
  }

  .bt-back {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 3.5rem;
    background: #ffffff;
    transition: 0.3s;
    cursor: pointer;
    filter: drop-shadow(3px 4px 7px rgba(165, 165, 165, 0.25));

    &:hover {
      background-color: #f3f3f3;
      filter: drop-shadow(1px 1px 3px rgba(165, 165, 165, 0.45));
    }
  }

  .link {
    color: #000;
    font-size: 1.6rem;
    text-decoration-line: underline;
    cursor: pointer;
  }
}

.footer {
  width: 100%;
  height: 0.1rem;
}

.bottom-screen {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1;

  .footer-modal {
    margin: auto;
    max-width: 48rem;
    padding: 2.4rem;
    height: 18rem;
    background-color: #fff;
    border-radius: 3rem 3rem 0 0;
    text-align: center;
  }
}

.question-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #000;
  user-select: none;
  // font-family: "Libre Caslon Text", serif;
}

.sex-container {
  .select-box {
    position: relative;
    width: 28rem;
    height: 13.2rem;
    border-radius: 15.2rem;
    background-color: #f5fbeb;
    cursor: pointer;

    .button {
      width: 11rem;
      height: 11rem;
      border-radius: 11rem;
      z-index: 1;
      user-select: none;
      transition: 0.3s;
      color: #525252;
      font-weight: 500;
      font-size: 1.6rem;
    }

    .button.focus {
      color: #206b5e;
    }

    .white-cyecle {
      background-color: white;
      position: absolute;
      box-shadow: 0.2rem 0.4rem 0.9rem rgba(141, 154, 132, 0.25);
    }

    .white-cyecle.M {
      left: 1rem;
    }

    .white-cyecle.F {
      left: calc(100% - (1rem + 11rem));
    }
  }
}

.career-container {
  .image-middle {
    height: 36rem;
    width: 36rem;
    max-height: 300px;
    max-width: 100vw;
  }
}

.health-details-container,
.activity-container,
.sports-container,
.body-details-container {
  .image-middle {
    height: 36rem;
    width: 36rem;
    max-height: 300px;
    max-width: 100vw;
  }

  .body {
    width: 100%;
    max-width: 300px;
    padding: 0px 10px;
    margin: auto;
  }
}

.exercise-week-container {
  .body {
    width: 100%;
    max-width: 400px;
    margin: auto;

    .selec-contariner {
      // width: 36rem;
      // height: 36rem;
      position: relative;
      // margin-bottom: 10px;
      margin: 2rem auto;

      .option-box {
        width: 80%;
        height: 5rem;
        border-radius: 2rem;
        margin: 2rem auto;
        background: #f3f3e7;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
        // position: absolute;
        font-weight: 500;
        color: #000;
        font-size: 1.6rem;
        cursor: pointer;
        user-select: none;
        transition: 0.3s;
        // &:hover {
        //   background: #f7f7f7;
        // }
      }

      .option-box.selected {
        width: 80%;
        height: 5rem;
        border-radius: 2rem;
        margin: 2rem auto;
        background: #ecf5ca;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
        // position: absolute;
        font-weight: 500;
        color: #000;
        font-size: 1.6rem;
        cursor: pointer;
        user-select: none;
        transition: 0.3s;
        // &:hover {
        //   background: #f7f7f7;
        // }
      }

      .top {
        top: 0;
      }

      .bottom {
        top: calc(36rem - 12.7rem);
      }

      .left {
        left: 1rem;
      }

      .right {
        left: calc(100% - 13rem);
      }

      .mid {
        top: calc((36rem - 11rem) / 2);
        left: calc((100% - 11rem) / 2);
      }

      .option-box-mid {
        width: 14rem;
        height: 14rem;
        border-radius: 14rem;
        background-color: rgba($color: #ecf5ca, $alpha: 0.7);
        color: #7b7b7b;
        font-size: 1.8rem;
        z-index: -2;
        transition: 0.3s;
      }

      .option-box-mid.select {
        background-color: #e2f2b9;
      }

      .check-icon {
        display: flex;
        // position: absolute;
        z-index: 999;
        top: 11rem;
        left: calc((100% + 3rem) / 2);
        width: 4.3rem;
        height: 4.3rem;
        cursor: pointer;
        opacity: 0;
      }

      .check-icon.select {
        opacity: 1;
      }
    }
  }
}

// .behavior-container {
//   .body {
//     width: 100%;
//     max-width: 350px;
//     margin: auto;
//     display: flex;
//     justify-content: space-around;
//     flex-wrap: wrap;
//     margin-top: 5.2rem;
//     @media only screen and (max-width: 514px) {
//       width: calc(100% - 1rem);
//       // padding: 0 3rem;
//     }
//     .behavior-card {
//       position: relative;
//       width: 100%;
//       max-width: 12rem;
//       height: 13rem;
//       border-radius: 2rem;
//       background: #f3f3e7;
//       transition: 0.3s;
//       cursor: pointer;
//       user-select: none;
//       margin-bottom: 3.6rem;
//       .icon {
//         width: 5rem;
//         height: 5rem;
//         border-radius: 5rem;
//         // background: #fff;
//         margin: auto;
//       }
//       .content {
//         height: 10rem;
//         padding-top: 1rem;
//         display: flex;
//         flex-direction: column;
//         justify-content: space-between;
//       }
//       .label {
//         width: 8rem;
//         margin: 0 auto;
//         font-size: 1.2rem;
//         text-align: center;
//         height: 4.8rem;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       }
//     }
//     .check-icon {
//       display: none;
//     }
//     // .behavior-card {
//     .behavior-card.select {
//       background-color: #ecf5ca;
//       .check-icon {
//         display: flex;
//         position: absolute;
//         top: -1.1rem;
//         right: -1.1rem;
//         width: 3.5rem;
//         height: 3.5rem;
//       }
//     }
//   }
// }

.behavior-container {
  .body {
    width: 100%;
    // max-width: 350px;
    margin: 1rem;
    // display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 5.2rem;
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
      // padding: 0 3rem;
    }

    .disease-long-card {
      background: #f3f3e7;
      width: 14rem;
      height: 14rem;
      margin: 0.5rem;
      text-align: left;
      display: inline;
      border-radius: 20px;
      // display: flex;
      align-items: center;
      position: relative;
      word-break: break-word;

      // &:hover {
      //   background: #EFF8E9;
      // }
      // background-color: green;
      .icon {
        width: auto;
        height: 5rem;
        // background-color: salmon;
        // margin: 8px 0px 8px 15px;
        // padding: 8px 0px 8px 15px;
        // margin: 2rem;
        display: flex;
        margin-top: 2rem;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        // background-color:red ;
      }

      .label {
        display: block;
        // margin-top: 2rem;
        margin-left: auto;
        margin-right: auto;
        // padding: 0px 20px 0px 20px;
        width: 80%;
        height: 8rem;
        text-align: center;
        //       display: flex;
        justify-content: center;
        line-height: 2rem;
        // background-color: red;
      }

      .check-icon {
        display: none;
      }
    }

    .disease-long-card.error {
      border: 1px solid red;
      outline: 1px solid red;
    }
    .disease-long-card.select {
      background-color: #ecf5ca;
      position: relative;

      .check-icon {
        display: flex;
        position: absolute;
        margin: -10px -10px 0px 0px;
        top: 0;
        right: 0;
        width: 3rem;
        height: 3rem;

        border-radius: 1.8rem;
        background-color: #206b5e;
      }
    }
  }
}

.disease-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 5.2rem;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
      // padding: 0 3rem;
    }

    .disease-long-card {
      background: #f3f3e7;
      width: 100%;
      // height: 5rem;
      margin: 0rem 3rem 1.5rem;
      text-align: left;
      display: inline;
      border-radius: 20px;
      display: flex;
      align-items: center;
      position: relative;

      // &:hover {
      //   background: #EFF8E9;
      // }
      .icon {
        width: 4rem;
        margin: 8px 0px 8px 20px;
      }

      .label {
        font-weight: 500;
        font-size: 1.4rem;
      }
    }

    .disease-long-card.error {
      border: 1px solid red;
      outline: 1px solid red;
    }
    .disease-long-card.select {
      background-color: #ecf5ca;
      position: relative;

      .check-icon {
        display: flex;
        position: absolute;
        margin: -10px -10px 0px 0px;
        top: 0;
        right: 0;
        width: 3rem;
        height: 3rem;
      }
    }

    .disease-card {
      position: relative;
      width: 45%;
      padding-top: 45%;
      height: 13rem;
      border-radius: 14rem;
      background: #fff;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 3.6rem;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:hover {
        background: #f6fbfc;
      }

      .icon {
        width: 5rem;
        height: 5rem;
        border-radius: 5rem;
        background: #fff;
        margin: auto;
      }

      .content {
        position: absolute;
        top: 0;

        // height: 10rem;
        padding-top: 2rem;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
      }

      .label {
        width: 8rem;
        margin: 0 auto;
        font-size: 1.2rem;
        text-align: center;
        height: 4.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .check-icon {
      display: none;
    }

    .disease-card.select {
      background-color: #f0f9fb;
      box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
        5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}

.disease-family-container {
  .slide-body {
    // width: calc(19.4rem * 3);
    max-width: 100%;
    // max-width: 600px;
    // margin: auto;
    margin: 5.2rem auto 0;

    // display: flex;
    // flex-wrap: nowrap;
    // overflow: auto;
    // @media only screen and (max-width: 514px) {
    //   width: calc(100% - 6rem);
    //   padding: 0 3rem;
    // }
    .slide-container {
      width: calc(14.3rem * 4);
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin: auto;
      padding: 1rem 0;
    }

    // .mock-time-card {
    //   width: 100%;
    //   height: 20rem;
    //   width: 20rem;
    //   border-radius: 20rem;
    //   margin: auto;
    // }
    .mock-time-card {
      height: 29rem;
      margin: auto;
    }

    .time-card {
      position: relative;
      // width: 100%;
      height: 24.6rem;
      width: 14.3rem;
      border-radius: 14.3rem;
      background: #fff;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin: 0 auto 1.2rem;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:hover {
        background: #f6fbfc;
      }

      .check-icon {
        display: none;
      }

      .icon {
        width: 5rem;
        height: 5rem;
        border-radius: 5rem;
        background: #fff;
        margin: auto;
      }

      .content {
        height: 10rem;
        padding-top: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .label {
        width: 8rem;
        margin: 0 auto;
        font-size: 1.4rem;
        text-align: center;
        height: 4.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .time-card.select {
      background-color: #eff8e9;
      height: 29rem;
      box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
        5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}

.activity-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;
    margin-top: 5.2rem;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
    }

    .btn-select {
      position: relative;
      width: 100%;
      height: 6rem;
      padding: 0 4rem;
      border-radius: 2rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 1.4rem;
      font-size: 1.3rem;
      font-weight: 500;

      .check-icon {
        display: none;
      }

      // &:hover {
      //   background: #EFF8E9;
      // }
    }

    .btn-select.select {
      background-color: #ecf5ca;

      .check-icon {
        margin: -10px -10px 0px 0px;
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 2.8rem;
        height: 2.8rem;
      }
    }
  }
}

.exercise-time-container {
  .slide-body {
    // width: calc(19.4rem * 3);
    max-width: 100%;
    // max-width: 600px;
    // margin: auto;
    margin: 5.2rem auto 0;

    // display: flex;
    // flex-wrap: nowrap;
    // overflow: auto;
    // @media only screen and (max-width: 514px) {
    //   width: calc(100% - 6rem);
    //   padding: 0 3rem;
    // }
    .slide-container {
      width: calc(19.4rem * 4);
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin: auto;
      padding: 1rem 0;
    }

    .mock-time-card {
      width: 100%;
      height: 20rem;
      width: 20rem;
      border-radius: 20rem;
      margin: auto;
    }

    .time-card {
      position: relative;
      width: 100%;
      height: 15.4rem;
      width: 15.4rem;
      border-radius: 15.4rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin: 0 auto 1.2rem;

      // box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      //   5px 5px 10px rgba(163, 162, 162, 0.25);
      // &:hover {
      //   background: #f6fbfc;
      // }
      .label {
        font-size: 1.6rem;
        font-weight: 500;
        width: 12rem;
        text-align: center;
      }

      .check-icon {
        display: none;
      }
    }

    .time-card.select {
      background-color: #eff8e9;
      height: 20rem;
      width: 20rem;
      border-radius: 20rem;
      // box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
      //   5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}

.sports-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
      padding: 0 3rem;
    }

    .sports-btn {
      position: relative;
      width: 100%;
      max-width: 10rem;
      height: 10rem;
      border-radius: 10rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 3.6rem;

      // box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      //   5px 5px 10px rgba(163, 162, 162, 0.25);
      // &:hover {
      //   background: #eff8e970;
      // }
      .label {
        transition: 0.3s;
        font-size: 1.8rem;
        font-weight: 500;
        opacity: 0.7;
        color: #000;
      }
    }

    .sports-btn.select {
      background-color: #ecf5ca;

      // box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
      //   5px 5px 6px rgba(163, 162, 162, 0.25);
      .label {
        opacity: 1;
      }
    }
  }
}

.finish-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;
    height: 40vh;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 6rem);
      padding: 0 3rem;
    }
  }
}

.absolute-text {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translate(-50%, -50%);
  font-size: 1.2rem;
  font-weight: 500;
  color: #a3a357;
  pointer-events: none;
}

.date-selected {
  height: calc(3.6rem * 3);
  width: 10rem;
}

.date-selected-date {
  height: calc(3.6rem * 3);
  width: 8rem;
}

.date-selected-month {
  height: calc(3.6rem * 3);
  width: 12rem;
}

.date-selected-year {
  height: calc(3.6rem * 3);
  width: 8rem;
}

.focus-bg-date {
  width: 6rem;
  height: 3.6rem;
  background: #f5fbeb;
  border-radius: 1.5rem;
}

.focus-bg-month {
  width: 12rem;
  height: 3.6rem;
  background: #f5fbeb;
  border-radius: 1.5rem;
}

.focus-bg-year {
  width: 7rem;
  height: 3.6rem;
  background: #f5fbeb;
  border-radius: 1.5rem;
}

.top-bottom-bg-date {
  width: 6rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.top-bottom-bg-month {
  width: 12rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.top-bottom-bg-year {
  width: 7rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.step-progress {
  height: 0.3rem;
  margin-top: 1.4rem;
  display: grid;
  grid-template-columns: repeat(10, calc(10% - (0.4rem / 9)));
  gap: 0.4rem;
  background-color: #f3f3e7;

  .step-bar {
    height: 0.3rem;
    width: 100%;
    background: #6db557;
  }
}

.el-select-dropdown__item.selected {
  color: #000;
}
</style>

<style lang="scss">
.focus-bg-exercise {
  width: 30rem;
  height: 4.8rem;
  background: #ecf5ca;
  border-radius: 1.8rem;
}

.top-bottom-bg-exercise {
  width: 30rem;
  height: calc(4.8rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff 0%, transparent 50%, #fff 100%);
}

.exercise-selected-exercise {
  height: calc(4.8rem * 3);
  width: 26rem;
}

#question_page {
  .date-input {
    width: 100%;
    max-width: 11.8rem;
    height: 3.6rem;
    border-radius: 3.6rem;

    .el-input__inner {
      font-size: 1.8rem;
      height: 3.6rem;
      border-radius: 3.6rem;
      border: 0;
      outline: 0;
      box-shadow: none;
      border: 1px solid #eff8e9;
      background-color: #eff8e9;
      text-align: center;

      &:focus {
        box-shadow: 0 0 0 1px #206b5e inset !important;
        border: 1px solid #206b5e;
      }
    }
  }

  .date-input.validate {
    .el-input__inner {
      outline: 1px solid red;
    }
  }

  .width-250 {
    max-width: 25rem;
  }

  .width-160 {
    max-width: 16rem;
  }

  .width-150 {
    max-width: 15rem;
  }
}

.yes-no-btn {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #f3f3e7;
  font-size: 1.8rem;
  font-weight: 500;
}

.yes-no-btn.select {
  background: #ecf5ca;
}
</style>
